webpackJsonp([1],{

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4trT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "52Ql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CmC0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e4cd6ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("52Ql")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36923708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("eJtY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ba18d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index + 1, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("X3WW")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ArticleNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ArticleNavigationBar = ({
  props: ['logoURL', 'title', 'page', 'companyName', 'width'],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['zoomEnabled', 'contentsEnabled', 'searchEnabled', 'languagesEnabled', 'downloadEnabled', 'printEnabled', 'rightToLeft', 'companyLogo', 'downloadPath', 'showContents', 'showLanguages', 'showSearch', 'isZoomed', "isArticle",
  // "showArticles",
  "articlesEnabled", "articleFontSize"]), {
    divider: function divider() {
      if (this.rightToLeft) return 'chevron-left';
      return 'chevron-right';
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleLanguages: 'TOGGLE_LANGUAGES',
    toggleZoom: 'TOGGLE_ZOOM',
    toggleSearch: 'TOGGLE_SEARCH',
    increaseArticleFontSize: 'INCREASE_ARTICLE_FONT_SIZE',
    decreaseArticleFontSize: 'DECREASE_ARTICLE_FONT_SIZE'
  }), {
    toggleArticles: function toggleArticles() {
      var e = document.getElementById('article-menu-sm');
      if (e.style.display == 'none') {
        e.style.display = 'block';
      } else {
        e.style.display = 'none';
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4653b7f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleNavigationBar.vue
var ArticleNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),(_vm.isArticle)?_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[_c('li',{staticClass:"nav-bar__link nav_link_hidden",on:{"click":function($event){_vm.toggleArticles()}}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1),_vm._v(" "),_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.increaseArticleFontSize}},[_c('feather-icon',{attrs:{"icon":"zoom-in"}})],1),_vm._v(" "),_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.decreaseArticleFontSize}},[_c('feather-icon',{attrs:{"icon":"zoom-out"}})],1)])]):_vm._e()])])}
var ArticleNavigationBar_staticRenderFns = []
var ArticleNavigationBar_esExports = { render: ArticleNavigationBar_render, staticRenderFns: ArticleNavigationBar_staticRenderFns }
/* harmony default export */ var components_ArticleNavigationBar = (ArticleNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/ArticleNavigationBar.vue
function ArticleNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("4trT")
}
var ArticleNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ArticleNavigationBar___vue_template_functional__ = false
/* styles */
var ArticleNavigationBar___vue_styles__ = ArticleNavigationBar_injectStyle
/* scopeId */
var ArticleNavigationBar___vue_scopeId__ = "data-v-4653b7f8"
/* moduleIdentifier (server only) */
var ArticleNavigationBar___vue_module_identifier__ = null
var ArticleNavigationBar_Component = ArticleNavigationBar_normalizeComponent(
  ArticleNavigationBar,
  components_ArticleNavigationBar,
  ArticleNavigationBar___vue_template_functional__,
  ArticleNavigationBar___vue_styles__,
  ArticleNavigationBar___vue_scopeId__,
  ArticleNavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_ArticleNavigationBar = (ArticleNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ArticleMenu.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ArticleMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["articles", "articleLink", "currentArticle"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({}), Object(vuex_esm["b" /* mapActions */])(["goToArticle"]))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-516cd5db","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleMenu.vue
var ArticleMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"article-menus"}},[_c('div',{attrs:{"id":"article-menu"}},[_c('ul',{attrs:{"id":"article-list"}},_vm._l((_vm.articles),function(article,index){return _c('li',{key:index,staticClass:"article-list",class:{active: article.articleIndex == _vm.currentArticle.articleIndex},on:{"click":function($event){_vm.goToArticle(index)}}},[_vm._v("\n          "+_vm._s(article.title)+"\n      ")])}))]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"article-menu-sm"}},[_c('ul',{attrs:{"id":"article-list"}},_vm._l((_vm.articles),function(article,index){return _c('li',{key:index,staticClass:"article-list",class:{active: article.articleIndex == _vm.currentArticle.articleIndex},on:{"click":function($event){_vm.goToArticle(index)}}},[_vm._v("\n          "+_vm._s(article.title)+"\n      ")])}))])])}
var ArticleMenu_staticRenderFns = []
var ArticleMenu_esExports = { render: ArticleMenu_render, staticRenderFns: ArticleMenu_staticRenderFns }
/* harmony default export */ var components_ArticleMenu = (ArticleMenu_esExports);
// CONCATENATED MODULE: ./src/components/ArticleMenu.vue
function ArticleMenu_injectStyle (ssrContext) {
  __webpack_require__("UFQQ")
}
var ArticleMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ArticleMenu___vue_template_functional__ = false
/* styles */
var ArticleMenu___vue_styles__ = ArticleMenu_injectStyle
/* scopeId */
var ArticleMenu___vue_scopeId__ = "data-v-516cd5db"
/* moduleIdentifier (server only) */
var ArticleMenu___vue_module_identifier__ = null
var ArticleMenu_Component = ArticleMenu_normalizeComponent(
  ArticleMenu,
  components_ArticleMenu,
  ArticleMenu___vue_template_functional__,
  ArticleMenu___vue_styles__,
  ArticleMenu___vue_scopeId__,
  ArticleMenu___vue_module_identifier__
)

/* harmony default export */ var src_components_ArticleMenu = (ArticleMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ArticlePage.vue

//
//
//
//
//
//
//
//
//




/* harmony default export */ var ArticlePage = ({
  components: {

    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["currentArticle", "nextArticle", "previousArticle"]), {
    options: function options() {
      return {
        width: 25,
        height: 25
      };
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(["goToNextArticle", "goToPreviousArticle"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4df1e5e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticlePage.vue
var ArticlePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"article-page"},[_c('article',{staticClass:"article-content",domProps:{"innerHTML":_vm._s(_vm.currentArticle.article)}}),_vm._v(" "),(_vm.previousArticle)?_c('div',{on:{"click":_vm.goToPreviousArticle}},[_c('feather-icon',{staticClass:"navigation-link navigation-article--prev",attrs:{"id":"article-previous","icon":"play","options":_vm.options}})],1):_vm._e(),_vm._v(" "),(_vm.nextArticle)?_c('div',{on:{"click":_vm.goToNextArticle}},[_c('feather-icon',{staticClass:"navigation-link navigation-article--next",attrs:{"id":"article-next","icon":"play","options":_vm.options}})],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"article-close","onclick":"Publish.closeArticle()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)])}
var ArticlePage_staticRenderFns = []
var ArticlePage_esExports = { render: ArticlePage_render, staticRenderFns: ArticlePage_staticRenderFns }
/* harmony default export */ var components_ArticlePage = (ArticlePage_esExports);
// CONCATENATED MODULE: ./src/components/ArticlePage.vue
function ArticlePage_injectStyle (ssrContext) {
  __webpack_require__("CmC0")
}
var ArticlePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ArticlePage___vue_template_functional__ = false
/* styles */
var ArticlePage___vue_styles__ = ArticlePage_injectStyle
/* scopeId */
var ArticlePage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ArticlePage___vue_module_identifier__ = null
var ArticlePage_Component = ArticlePage_normalizeComponent(
  ArticlePage,
  components_ArticlePage,
  ArticlePage___vue_template_functional__,
  ArticlePage___vue_styles__,
  ArticlePage___vue_scopeId__,
  ArticlePage___vue_module_identifier__
)

/* harmony default export */ var src_components_ArticlePage = (ArticlePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ArticleContainer.vue

//
//
//
//
//
//
//
//
//







/* harmony default export */ var ArticleContainer = ({
  components: {
    ArticleNavigationBar: src_components_ArticleNavigationBar,
    ArticleMenu: src_components_ArticleMenu,
    ArticlePage: src_components_ArticlePage,
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["currentArticle", "nextArticle", "previousArticle"]
  // "showArticles"
  ), {
    options: function options() {
      return {
        width: 25,
        height: 25
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c35ec1fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleContainer.vue
var ArticleContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"article-container"}},[_c('article-navigation-bar'),_vm._v(" "),_c('article-page'),_vm._v(" "),_c('article-menu')],1)}
var ArticleContainer_staticRenderFns = []
var ArticleContainer_esExports = { render: ArticleContainer_render, staticRenderFns: ArticleContainer_staticRenderFns }
/* harmony default export */ var components_ArticleContainer = (ArticleContainer_esExports);
// CONCATENATED MODULE: ./src/components/ArticleContainer.vue
function ArticleContainer_injectStyle (ssrContext) {
  __webpack_require__("RIzX")
}
var ArticleContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ArticleContainer___vue_template_functional__ = false
/* styles */
var ArticleContainer___vue_styles__ = ArticleContainer_injectStyle
/* scopeId */
var ArticleContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ArticleContainer___vue_module_identifier__ = null
var ArticleContainer_Component = ArticleContainer_normalizeComponent(
  ArticleContainer,
  components_ArticleContainer,
  ArticleContainer___vue_template_functional__,
  ArticleContainer___vue_styles__,
  ArticleContainer___vue_scopeId__,
  ArticleContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_ArticleContainer = (ArticleContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer,
    ArticleContainer: src_components_ArticleContainer,
    ArticleNavigationBar: src_components_ArticleNavigationBar
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isArticle', 'articleFontSize', 'pageContainerZoomLevel', 'pageScale'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }

    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      console.log('BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB');
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      console.log('DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD');
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA');
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        console.log('CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC');
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        console.log('FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF');
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });

        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    changeSize: function changeSize() {
      // if(this.currentPage.pageIndex == 0){
      //   // this.changePageSize({
      //   //   double: true
      //   // })
      // } else {
      //   this.changePageSize({
      //     double: false
      //   })
      // }
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize', 'changePageSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02729127","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.isArticle)?[_c('article-container')]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":page.pageIndex == 0 ? _vm.width * 2 - 32 : _vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("wA9t")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_IS_FRONT_PAGE = 'UPDATE_IS_FRONT_PAGE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var OPEN_ARTICLE = 'OPEN_ARTICLE';
var CLOSE_ARTICLE = 'CLOSE_ARTICLE';

var INCREASE_ARTICLE_FONT_SIZE = 'INCREASE_ARTICLE_FONT_SIZE';
var DECREASE_ARTICLE_FONT_SIZE = 'DECREASE_ARTICLE_FONT_SIZE';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/document.js


var _ref, _ref2;

/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Cartier Philanthropy – Dix ans de philanthropy efficace",
  "shortTitle": "",
  "description": "",
  "width": 714,
  "height": 868,
  "currentLanguage": "FR",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "https://reports.cartierphilanthropy.org/a-decade-of-effective-philanthropy/en"
  }, {
    "code": "FR",
    "text": "French",
    "href": "https://reports.cartierphilanthropy.org/a-decade-of-effective-philanthropy/fr"
  }],
  "basePath": "/a-decade-of-effective-philanthropy/fr",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "https://reports.cartierphilanthropy.org/a-decade-of-effective-philanthropy/fr/static/_thumbs",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/a-decade-of-effective-philanthropy/fr/static/_content/Cartier-Philanthropy-Dix-ans-de-philanthropy-efficace.pdf',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 2-logo\" style=\"top:228px;left:963px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/2-logo-1.png\">\n        <img class=\"abs halfScale 2-title\" style=\"top:513px;left:1051px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/2-title-1.png\">\n        <img class=\"abs halfScaleC 2-logo\" style=\"top:740px;left:1031px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/2-logo-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim\n            .staggerFromTo(cOf(\"2-logo\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.6, 1)\n            .fromTo(cOf(\"2-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          resetNumbers(\"2-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DIX ANS DE PHILANTHROPIE E FFI C A C E"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 3-title\" style=\"top:105px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/3-title-1.png\">\n        <img class=\"abs halfScaleC 3-pie\" style=\"top:309px;left:136px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-1.png\">\n        <img class=\"abs halfScaleC 3-pie\" style=\"top:309px;left:136px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-2.png\">\n        <img class=\"abs halfScaleC 3-pie\" style=\"top:309px;left:136px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-3.png\">\n        <img class=\"abs halfScaleC 3-pie\" style=\"top:309px;left:136px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-4.png\">\n        <img class=\"abs halfScaleC 3-pie\" style=\"top:309px;left:136px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-5.png\">\n        <img class=\"abs halfScaleC 3-pie\" style=\"top:309px;left:136px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-6.png\">\n        <h1 id=\"3-no\" class=\"abs brillCutReg 3-no\" style=\"top:176px;left:254px; font-size: 4.4em; font-weight: 300; color: #868687; padding: 0px; margin: 0px;\"  data-number='{\"to\": 100, \"comma\": true}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutReg 3-no\" style=\"top:286px;left:391px; font-size: 4.4em; font-weight: 300; color: #868687; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50, \"preppend\": \"+\"}' ></h1>\n\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:476px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 52, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:500px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 25, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:523px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:561px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 6, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:584px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:608px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 6, \"append\": \"%\"}' ></h1>\n        ",
    "script": "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n          pg3Anim\n            .fromTo(cOf(\"3-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .staggerFromTo(cOf(\"3-pie\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.9)\n          \n          animateNumbers(\"3-no\", 1.3)\n        }\n        \n        function onPageLeave() {\n          pg3Anim.stop();\n          resetNumbers(\"3-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n        ",
    "searchText": "ALLOCATION BUDGÉTAIRE  100  millions de francs suisses investis sur les dix dernières années  +50 Distribution géographique 5 2% Afrique 2 5% Asie 1 0% Amérique centrale & latine 6 % Europe* 1% Moyen-Orient 6% Autres*  *Inclut un soutien exceptionnel pendant la pandémie de Coronavirus (2020-2022)  2-  pays"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"3-no\" class=\"abs brillCutReg 3-no\" style=\"top:241px;left:81px; font-size: 4.4em; font-weight: 300; color: #868687; padding: 0px; margin: 0px;\"  data-number='{\"to\": 80, \"preppend\": \"+\"}' ></h1>\n\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:476px;left:105px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 41, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:476px;left:311px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 23, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:476px;left:428px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 21, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:476px;left:537px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 15, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:766px;left:115px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 33, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:766px;left:268px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px;margin: 0px;\"  data-number='{\"to\": 24, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:766px;left:390px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 23, \"append\": \"%\"}' ></h1>\n        <h1 id=\"3-no\" class=\"abs brillCutBold 3-no\" style=\"top:766px;left:498px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 20, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n\n          animateNumbers(\"3-no\", 1.3)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          resetNumbers(\"3-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "+80  partenaires  Par secteur 4 1% Accès aux services de base  33% Éducation  2 3% Développement social et économique des femmes  24% Santé  2 1% Modes de subsistance et écosystèmes durables  23% Eau et assainissement  1 5% Réponse aux situations d’urgence  20% Nutrition  - 3"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 6-title\" style=\"top:286px;left:333px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/6-title-1.png\">\n        <img class=\"abs halfScale 6-title\" style=\"top:384px;left:357px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/6-text-1.png\">\n        <img class=\"abs halfScale 6-title\" style=\"top:478px;left:357px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/6-text-2.png\">\n        <img class=\"abs halfScale 6-title\" style=\"top:574px;left:357px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/6-text-3.png\">\n        <img class=\"abs halfScale 6-title\" style=\"top:669px;left:357px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/6-text-4.png\">\n\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(6);\" style=\"top: 379px; left: 353px; width: 186px; height: 44px;\"></div>\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(7);\" style=\"top: 476px; left: 353px; width: 270px; height: 44px;\"></div>\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(8);\" style=\"top: 571px; left: 353px; width: 298px; height: 44px;\"></div>\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(42);\" style=\"top: 652px; left: 353px; width: 308px; height: 61px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim\n            .staggerFromTo(cOf(\"6-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n          resetNumbers(\"6-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SOM M A I R E  06  Message du Président  07  Message de la Conseillère stratégique  08  Dix ans d’impact collectif dans nos domaines clés  42  Les cinq leçons tirées d’une décennie d’engagement  XXX - 5"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 7-title\" style=\"top:87px;left:88px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/7-title-1.png\">\n\n      <div class=\"contentLinkNone abs\" style=\"top: 195px; left: 282px; width: 368px; height: 567px;\" onclick=\"Publish.openArticle(0)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim\n            .fromTo(cOf(\"7-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop();\n          resetNumbers(\"7-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "MESSAGE DU PRÉSIDENT  CYRILLE VIGNERON  Président et CEO de Cartier, Président du conseil de fondation Cartier Philanthropy  6-  La mission de Cartier est de trouver la beauté, où qu’elle soit. Nous sommes à son service et, tous les jours, nous nous efforçons de la sublimer afin qu’elle perdure pour les générations à venir. Nous estimons qu’il est de notre responsabilité, à la fois en tant qu’être humain et en tant qu’entreprise, de cultiver et de protéger la beauté du monde, et de faire tout notre possible pour la restaurer quand elle a été détériorée ou brisée. La vie humaine est évidemment l’une des beautés du monde. La beauté, telle que nous la concevons, est donc un idéal qui ne peut être atteint que par le soin, le respect, la dignité et la compassion. Au cours de cette dernière décennie, Cartier Philanthropy a travaillé avec ténacité et efficacité pour améliorer la vie des communautés les plus vulnérables et les plus marginalisées de la planète, afin qu’elles puissent non seulement survivre aux épreuves, mais vivre, profiter et participer pleinement à la beauté du monde. Une jeune fille qui termine avec succès sa scolarité, une communauté d’agriculteurs prospère, un endroit sûr où trouver refuge et se reconstruire, un nouveau-né en bonne santé… sont autant d’expressions de la beauté - une beauté vivante. Cartier Philanthropy soutient des organisations dont la mission est de donner aux femmes, aux enfants et à des communautés entières les ressources, les compétences et les opportunités dont ils ont besoin pour vivre pleinement. Au fil des années, de solides partenariats ont été noués et construits sur des valeurs communes et un engagement mutuel en faveur d’une philanthropie efficace. Le chemin est encore long. En effet, à certaines occasions, il peut même nous paraître plus sinueux qu’il ne l’était il y a dix ans. Mais chaque pas et chaque vie changée viennent réaffirmer notre confiance et notre détermination, et ouvrent en peu plus la voie afin que d’autres nous rejoignent pour créer ensemble de nouvelles beautés dans le monde."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 8-title\" style=\"top:87px;left:72px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/8-title-1.png\">\n        <div class=\"contentLinkNone abs\" style=\"top: 195px; left: 264px; width: 368px; height: 631px;\" onclick=\"Publish.openArticle(1)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim\n            .fromTo(cOf(\"8-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n          resetNumbers(\"8-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "MESSAGE DE LA CONSEILLÈRE STRATÉGIQUE  PASCALE DE LA FRÉGONNIÈRE Conseillère stratégique Cartier Philanthropy  Quelle aventure ces dix dernières années ! Et quel privilège que celui de guider Cartier Philanthropy, des promesses initiales aux progrès tangibles, en créant un solide réseau de partenaires dont nous sommes très fiers ! Nous sommes aujourd’hui heureux de voir, aux quatre coins du monde, des communautés plus fortes et pleines de ressources, en mesure de surmonter de sérieux obstacles et de vivre enfin comme elles le méritent. Cartier Philanthropy a été fondé il y a dix ans afin de participer à la construction d’un monde dans lequel chacun peut réaliser son potentiel. Au cours de la dernière décennie, nous nous sommes concentrés sur cette ambition de manière stratégique. Nous avons choisi de nous focaliser sur les endroits les plus vulnérables de la planète et avons progressivement défini le cadre de notre champ d’action, en accordant une attention particulière aux inégalités qui maintiennent les gens dans la pauvreté. La philanthropie relève de l’action collective et d’objectifs communs. Avec nos partenaires, nous nous attaquons sans relâche à ces inégalités, qu’elles soient liées au genre, à l’accès aux services essentiels ou au manque de ressources matérielles et sociales. Ce rapport met en lumière l’impact de notre engagement collectif et les changements concrets qui ont permis d’améliorer la vie des plus démunis. C’est notre façon d’honorer nos partenaires pour leur courage et leur détermination dans leur combat au service des plus vulnérables, quelles que soient les difficultés. Car ce combat est aussi le nôtre. Conscients qu’une évolution significative et durable ne se produit que si nous nous concentrons aussi sur notre façon de donner afin de contribuer à un impact social fort, nous partageons aussi dans ce rapport certaines des leçons que nous avons apprises en chemin, nous aidant à devenir une fondation meilleure, plus efficace, responsable et participative. Construire une société inclusive, équitable et plus sûre, qui offre à chacun la possibilité de mener une vie épanouissante, reste un impératif moral et le défi de notre époque. Notre engagement demeure inchangé, tout comme notre ambition de soutenir et de déployer des interventions éprouvées à l’échelle des besoins du plus grand nombre. - 7"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 10-title\" style=\"top:365px;left:335px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/10-title-1.png\">\n        <img class=\"abs halfScale 10-title\" style=\"top:433px;left:332px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/10-sub-1.png\">\n        <img class=\"abs halfScale 10-title\" style=\"top:590px;left:357px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/10-text-1.png\">\n        <img class=\"abs halfScale 10-title\" style=\"top:642px;left:357px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/10-text-2.png\">\n        <img class=\"abs halfScale 10-title\" style=\"top:716px;left:357px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/10-text-3.png\">\n        <img class=\"abs halfScale 10-title\" style=\"top:786px;left:357px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/10-text-4.png\">\n\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(11);\" style=\"top: 588px; left: 351px; width: 290px; height: 24px;\"></div>\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(19);\" style=\"top: 642px; left: 351px; width: 290px; height: 41px;\"></div>\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(27);\" style=\"top: 714px; left: 351px; width: 290px; height: 41px;\"></div>\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(35);\" style=\"top: 784px; left: 351px; width: 290px; height: 43px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim\n            .staggerFromTo(cOf(\"10-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop();\n          resetNumbers(\"10-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DIX ANS D’IMPACT COLLECTIF DANS NOS DOMAINES CLÉS 1.  ACCÈS AUX SERVICES DE BASE 2. DÉVELOPPEMENT SOCIAL ET ÉCONOMIQUE DES FEMMES 3. MODES DE SUBSISTANCE ET ÉCOSYSTÈMES DURABLES 4. RÉPONSE AUX SITUATIONS D’URGENCE XXX - 9"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "10 - X X X"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 12-title\" style=\"top:263px;left:332px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/12-title-1.png\">\n        <img class=\"abs halfScale 12-title\" style=\"top:426px;left:331px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/12-text-1.png\">\n        <div class=\"12-play pointer abs\" onclick=\"Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/Cartier_Access to Basic Services_V9_Subbed.mp4')\" style=\"top: 356px; left: 545px; filter: invert(1);\">\n          <img class=\"abs halfScaleC halfpulseBig animatedpulse\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/play.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim\n            .staggerFromTo(cOf(\"12-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"12-play\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          resetNumbers(\"12-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ACCÈS AUX SERVICES DE BASE Pour mener une vie épanouie, nos besoins fondamentaux doivent être satisfaits. Ces besoins comprennent l’accès aux soins médicaux, à une éducation de qualité, à une alimentation équilibrée, à l’eau potable et à l’assainissement. Durant cette dernière décennie, nous nous sommes associés à des douzaines d’organisations qui travaillent sans relâche et avec rigueur afin d’améliorer l’accès à ces services de base dans les régions les plus reculées du monde. XXX - 11"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 13-title\" style=\"top:101px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/13-title-1.png\">\n        <img class=\"abs halfScaleR 13-line\" style=\"top:98px;left:-715px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/13-line-1.png\">\n        <h1 id=\"13-no\" class=\"abs fancyCutMediumStretch 13-no\" style=\"top: 406px; left: 110px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 30, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScale 13-text\" style=\"top:439px;left:103px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/13-text-1.png\">\n        <img class=\"abs halfScale 13-image\" style=\"top:566px;left:102px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/13-image-1.png\">\n        <img class=\"abs halfScaleR 13-line\" style=\"top:423px;left:-109px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/13-line-2.png\">\n        <h1 id=\"13-no\" class=\"abs fancyCutMediumStretch 13-no\" style=\"top: 625px; left: 501px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 38, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScale 13-text\" style=\"top:658px;left:493px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/13-text-2.png\">\n        <img class=\"abs halfScale 13-image\" style=\"top:407px;left:352px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/13-image-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim\n            .fromTo(cOf(\"13-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"13-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"13-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no\")[0])}}, 1.45)\n            .fromTo(cOf(\"13-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(cOf(\"13-image\")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"13-line\")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"13-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no\")[1])}}, 2.35)\n            .fromTo(cOf(\"13-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"13-image\")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop();\n          resetNumbers(\"13-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ACCÈS AUX SOINS DE SANTÉ  Tog o  30%  baisse du taux de mortalité des enfants de moins de cinq ans, sur une période de cinq ans, grâce à la prise en charge communautaire de Santé Intégrée dans le district de Kozah  Zambie  0  14%  baisse au niveau national  0  38%  15 15 30 30  12 - A CCÈ S A UX SER VICES D E BA SE  réduction de la morbidité des élèves dans les écoles de Lusaka où les enseignants sont formés comme agents de santé scolaire par Healthy Learners"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"14-no\" class=\"abs fancyCutMediumStretch 14-no\" style=\"top: 640px; left: 241px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 33, \"append\": \"%\"}' ></h1>\n      <img class=\"abs halfScale 14-line-b\" style=\"top:445px;left:424px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/14-line-3.png\">\n      <img class=\"abs halfScale 14-text\" style=\"top:674px;left:234px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/14-text-1.png\">\n      <img class=\"abs halfScale 14-image\" style=\"top:576px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/14-image-1.png\">\n      <img class=\"abs halfScale 14-map\" style=\"top:111px;left:79px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/14-map-1.png\">\n      <img class=\"abs halfScaleR 14-line\" style=\"top:98px;left:-1429px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/13-line-1.png\">\n        <img class=\"abs halfScaleR 14-line\" style=\"top:423px;left:-822px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/13-line-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim\n            .fromTo(cOf(\"14-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"14-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"14-line\")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"14-image\")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"14-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"14-no\")[0])}}, 2.35)\n            .fromTo(cOf(\"14-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"14-line-b\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.65)\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n          resetNumbers(\"13-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "AFRIQUE  0  15  30  33%  baisse du taux de Madagascar mortalité infantile dans les zones du district d’Ifanadiana où les équipes de Pivot ont travaillé entre 2014 et 2021, contre une hausse de 48 % ailleurs dans le district AC C ÈS AUX S ERVIC ES DE BAS E - 13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 15-title\" style=\"top:101px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/15-title-1.png\">\n        <img class=\"abs halfScaleR 15-line\" style=\"top:190px;left:-838px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/15-line-1.png\">\n        <h1 id=\"15-no\" class=\"abs fancyCutMediumStretch 15-no\" style=\"top: 685px; left: 112px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 75, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScale 15-text\" style=\"top:718px;left:104px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/15-text-2.png\">\n        <img class=\"abs halfScale originBC 15-image\" style=\"bottom:199px;left:10px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/15-image-1.png\">\n        <img class=\"abs halfScaleR 15-line\" style=\"top:271px;left:-290px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/15-line-2.png\">\n        <h1 id=\"15-no\" class=\"abs fancyCutMediumStretch 15-no\" style=\"top: 392px; left: 492px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 19, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScale 15-text\" style=\"top:423px;left:487px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/15-text-1.png\">\n        <img class=\"abs halfScale originBC 15-image\" style=\"bottom:307px;left:314px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/15-image-2.png\">\n        <img class=\"abs halfScaleC 15-image\" style=\"top:479px;left:170px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/15-image-3.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim\n            .fromTo(cOf(\"15-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"15-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"15-image\")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.45)\n            .fromTo(cOf(\"15-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"15-no\")[0])}}, 1.6)\n            .fromTo(cOf(\"15-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)\n            .fromTo(cOf(\"15-line\")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"15-image\")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"15-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"15-no\")[1])}}, 2.35)\n            .fromTo(cOf(\"15-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"15-image\")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.8)\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n          resetNumbers(\"15-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ACCÈS À L’ÉDUCATION  É t h iop ie  R w a nd a  75  19% 60  45  30  15  0  75%  des élèves du programme « Seconde Chance » de Luminos Fund sont toujours scolarisés six ans plus tard 14 - A CCÈ S A UX SER VICES D E BA SE  15  0  taux d’amélioration de la résilience émotionnelle chez les enfants inscrits au programme de formation à la résilience de CorStone au Rwanda"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleR 16-line\" style=\"top:190px;left:-1551px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/15-line-1.png\">\n        <img class=\"abs halfScaleR 16-line\" style=\"top:271px;left:-1004px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/15-line-2.png\">\n        <img class=\"abs halfScaleR 16-line\" style=\"top:173px;left:218px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/16-line-3.png\">\n        <img class=\"abs halfScale originBC 16-image\" style=\"bottom:58px;left:175px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/16-image-1.png\">\n        <h1 id=\"16-no\" class=\"abs fancyCutMediumStretch 16-no\" style=\"top: 503px; left: 439px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 66, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScale 16-text\" style=\"top:537px;left:431px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/16-text-1.png\">\n        <div class=\"abs\" style=\"top: 581px; left: -1px; width: 5px; height: 241px; background: white;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim\n            .fromTo(cOf(\"16-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"16-line\")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"16-line\")[2], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.35)\n            .fromTo(cOf(\"16-image\")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"16-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[0])}}, 2.65)\n            .fromTo(cOf(\"16-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          resetNumbers(\"16-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "Bangladesh  66% 60  45  30  taux d’amélioration de l’alphabétisation chez les enfants qui utilisent le modèle d’apprentissage sur tablette d’Image Worldwide, éprouvé au Malawi et désormais testé au Bangladesh  15  0  AC C ÈS AUX S ERVIC ES DE BAS E - 15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 17-title\" style=\"top:83px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/17-title-1.png\">\n        <img class=\"abs halfScaleR 17-line\" style=\"top:304px;left:-64px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/17-line-1.png\">\n        <h1 id=\"17-no\" class=\"abs fancyCutMediumStretch 17-no\" style=\"top: 461px; left: 117px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 12600, \"comma\": true}' ></h1>\n        <img class=\"abs halfScale 17-text\" style=\"top:496px;left:105px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/17-text-1.png\">\n        <img class=\"abs halfScale originBC 17-image\" style=\"bottom:42px;left:1px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/17-image-1.png\">\n        <img class=\"abs halfScaleR 17-line\" style=\"top:290px;left:103px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/17-line-2.png\">\n        <h1 id=\"17-no\" class=\"abs fancyCutMediumStretch 17-no\" style=\"top: 615px; left: 115px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 300000, \"comma\": true}' ></h1>\n        <h1 id=\"17-no\" class=\"abs fancyCutMediumStretch 17-no\" style=\"top: 662px; left: 475px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 12000, \"comma\": true, \"preppend\": \"+\"}' ></h1>\n        <img class=\"abs halfScale 17-text\" style=\"top:696px;left:466px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/17-text-2.png\">\n        <img class=\"abs halfScale originBC 17-image\" style=\"bottom:219px;left:322px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/17-image-2.png\">\n        <img class=\"abs halfScaleC 17-image\" style=\"top:258px;left:205px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/17-image-3.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n          pg17Anim\n            .fromTo(cOf(\"17-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"17-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"17-image\")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)\n            .fromTo(cOf(\"17-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[0])}}, 1.6)\n            .fromTo(cOf(\"17-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)\n            .fromTo(cOf(\"17-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[1])}}, 1.75)\n            .fromTo(cOf(\"17-image\")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"17-line\")[1], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"17-image\")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.35)\n            .fromTo(cOf(\"17-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"17-no\")[2])}}, 2.5)\n            .fromTo(cOf(\"17-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.65)\n        }\n\n        function onPageLeave() {\n          pg17Anim.stop();\n          resetNumbers(\"17-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ACCÈS À L’EAU, À L’ASSAINISSEMENT ET À LA NUTRITION  Guatemala  Haïti  12 600  agriculteurs ont cultivé des semences bio-fortifiées de Semilla Nueva en 2021, ce qui a permis de fournir du maïs nutritif à plus de  300 000 personnes  +12 000  Haïtiens utilisent aujourd’hui les toilettes conçues par SOIL ainsi que le service de collecte et de transformation des déchets en compost  16 - A CCÈ S A UX SER VICES D E BA SE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleR 18-line\" style=\"top:311px;left:-64px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/18-line-1.png\">\n        <img class=\"abs halfScale 18-text\" style=\"top:594px;left:344px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/18-text-1.png\">\n        <img class=\"abs halfScale originBC 18-image\" style=\"bottom:48px;left:-22px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/18-image-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim\n            .fromTo(cOf(\"18-line\"), 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"18-image\"), 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.45)\n            .fromTo(cOf(\"18-text\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n          resetNumbers(\"18-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "C am b o d g e  1 ménage sur 4  dans les régions rurales du Cambodge – 850 000 personnes – boit de l’eau potable chaque jour grâce aux kiosques à eau de 1001fontaines AC C ÈS AUX S ERVIC ES DE BAS E - 17"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "18 - X X X"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 20-title\" style=\"top:251px;left:332px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/20-title-1.png\">\n        <img class=\"abs halfScale 20-title\" style=\"top:453px;left:332px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/20-text-1.png\">\n        <div class=\"20-play pointer abs\" onclick=\"Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/womens_engagement_V7_Hardsubbed.mp4')\" style=\"    top:379px; left: 620px; filter: invert(1);\">\n          <img class=\"abs halfScaleC halfpulseBig animatedpulse\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/play.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim\n            .staggerFromTo(cOf(\"20-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"20-play\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop();\n          resetNumbers(\"20-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DÉVELOPPEMENT SOCIAL ET ÉCONOMIQUE DES FEMMES Pendant dix ans, nous avons aidé nos partenaires à s’attaquer aux déséquilibres de pouvoir, aux préjugés et stéréotypes de genre et aux barrières sociales et économiques qui freinent l’avancement des femmes. Leurs remarquables résultats en matière de santé, de droits reproductifs, d’opportunités professionnelles, d’entrepreneuriat, d’éducation et de libre arbitre ont contribué à bâtir un monde plus équitable. XXX - 19"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 21-title\" style=\"top:100px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/21-title-1.png\">\n        <img class=\"abs halfScaleR 21-line\" style=\"top:218px;left:-332px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/21-line-1.png\">\n        <h1 id=\"21-no\" class=\"abs fancyCutMediumStretch 21-no\" style=\"top: 364px; left: 278px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2000, \"comma\": true}' ></h1>\n        <img class=\"abs halfScale 21-text\" style=\"top:397px;left:266px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/21-text-1.png\">\n        <img class=\"abs halfScale originBC 21-image\" style=\"bottom:520px;left:5px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/21-image-1.png\">\n        <h1 id=\"21-no\" class=\"abs fancyCutMediumStretch 21-no\" style=\"top: 364px; left: 98px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 770000, \"preppend\": \"+\", \"comma\": true}' ></h1>\n        <img class=\"abs halfScale 21-text\" style=\"top:399px;left:88px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/21-text-2.png\">\n        <img class=\"abs halfScaleR 21-line\" style=\"top:381px;left:-389px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/21-line-2.png\">\n        <img class=\"abs halfScale originBC 21-image\" style=\"bottom:123px;left:8px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/21-image-2.png\">\n        <h1 id=\"21-no\" class=\"abs fancyCutMediumStretch 21-no\" style=\"top: 724px; left: 269px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 0.8, \"append\": \"%\", \"decimals\": 1}' ></h1>\n        <img class=\"abs halfScaleC 21-text\" style=\"top:723px;left:74px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/21-text-3.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim\n            .fromTo(cOf(\"21-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"21-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"21-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[0])}}, 1.45)\n            .fromTo(cOf(\"21-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(cOf(\"21-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"21-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[1])}}, 2.05)\n            .fromTo(cOf(\"21-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"21-line\")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"21-image\")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)\n            .fromTo(cOf(\"21-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[2])}}, 2.8)\n            .fromTo(cOf(\"21-text\")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n          resetNumbers(\"21-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "SANTÉ DES FEMMES  Sénégal  +770 000 grossesses non désirées évitées au Sénégal depuis 2011 grâce aux services de MSI Reproductive Choices  2 000  décès maternels évités depuis 2011  = 100 décès maternels  Ouganda  0,8%  taux de transmission du VIH-SIDA de la mère à l’enfant en Ouganda où l’organisation mothers2mothers est active, contre un taux de 40 % où ses services ne sont pas présents 20 - DÉ V E LO PP EM EN T SO CIA L ET ÉCO N O MIQUE DES FEMMES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleR 22-line\" style=\"top:218px;left:-1046px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/21-line-1.png\">\n        <img class=\"abs halfScaleR 22-line\" style=\"top:381px;left:-1104px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/21-line-2.png\">\n        <h1 id=\"22-no\" class=\"abs fancyCutMediumStretch 22-no\" style=\"top: 719px; left: 359px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 120000, \"comma\": true}' ></h1>\n        <img class=\"abs halfScale 22-text\" style=\"top:754px;left:347px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/22-text-1.png\">\n        <img class=\"abs halfScale originBC 22-image\" style=\"bottom:50px;left:-119px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/22-image-1.png\">\n        <img class=\"abs halfScaleR 22-line-b\" style=\"top:467px;left:237px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/22-line-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim\n            .fromTo(cOf(\"22-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"22-line\")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"22-line-b\"), 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)\n            .fromTo(cOf(\"22-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[0])}}, 2.95)\n            .fromTo(cOf(\"22-text\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)\n            .fromTo(cOf(\"22-image\"), 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.15)\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n          resetNumbers(\"22-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "AFRIQUE  Zambie  120 000  femmes souffrant de dépression traitées en Zambie par le modèle de thérapie collective de StrongMinds  D É VELOPPEMENT S OC IAL ET ÉC ONOMIQUE DES FEMMES - 21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 23-title\" style=\"top:99px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/23-title-1.png\">\n        <img class=\"abs halfScaleR 23-line\" style=\"top:221px;left:-721px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/23-line-1.png\">\n        <h1 id=\"23-no\" class=\"abs fancyCutMediumStretch 23-no\" style=\"top: 274px; left: 434px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1.1, \"decimals\": 1, \"append\": \"M\"}' ></h1>\n        <img class=\"abs halfScale 23-text\" style=\"top:310px;left:427px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/23-text-1.png\">\n        <img class=\"abs halfScale originBC 23-image\" style=\"bottom:467px;left:172px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/23-image-1.png\">\n        <h1 id=\"23-no\" class=\"abs fancyCutMediumStretch 23-no\" style=\"top: 503px; left: 100px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 15000, \"comma\": true}' ></h1>\n        <img class=\"abs halfScale 23-text\" style=\"top:430px;left:85px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/23-text-2.png\">\n        <img class=\"abs halfScale originBC 23-image\" style=\"bottom:63px;left:331px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/23-image-2.png\">\n        <h1 id=\"23-no\" class=\"abs fancyCutMediumStretch 23-no\" style=\"top: 590px; left: 521px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 90, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScaleC 23-image\" style=\"top:488px;left:-59px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/23-image-3.png\">\n        <img class=\"abs halfScaleC 23-text\" style=\"top:600px;left:473px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/23-text-3.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim\n            .fromTo(cOf(\"23-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"23-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"23-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)\n            .fromTo(cOf(\"23-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"23-no\")[0])}}, 1.6)\n            .fromTo(cOf(\"23-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)\n            .fromTo(cOf(\"23-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"23-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"23-no\")[1])}}, 2.2)\n            .fromTo(cOf(\"23-image\")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"23-image\")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.8)\n            .fromTo(cOf(\"23-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"23-no\")[2])}}, 2.95)\n            .fromTo(cOf(\"23-text\")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n          resetNumbers(\"23-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ÉDUCATION ET COMPÉTENCES DE VIE 1,1M de filles indiennes de retour à l’école grâce à Educate Girls  Inde  15 000  bénévoles communautaires composent l’équipe d’Educate Girls  = 250 bénévoles communautaires  100%  90%  taux de rétention des élèves  0%  22 - DÉ V E LO PP EM EN T SO CIA L ET ÉCO N O MIQUE DES FEMMES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleR 24-line\" style=\"top:221px;left:-1437px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/23-line-1.png\">\n        <img class=\"abs halfScaleR 24-line\" style=\"top:420px;left:311px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/24-line-2.png\">\n        <img class=\"abs halfScaleR 24-line\" style=\"top:277px;left:154px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/24-line-1.png\">\n        <img class=\"abs halfScale originBC 24-image\" style=\"bottom:123px;left:-40px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/24-image-1.png\">\n        <h1 id=\"24-no\" class=\"abs fancyCutMediumStretch 24-no\" style=\"top: 670px; left: 137px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 79, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScale 24-text\" style=\"top:755px;left:72px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/24-text-1.png\">\n        <h1 id=\"24-no\" class=\"abs fancyCutMediumStretch 24-no\" style=\"top: 708px; left: 396px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 23, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScale 24-text\" style=\"top:742px;left:391px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/24-text-2.png\">\n        <img class=\"abs halfScale originBC 24-image\" style=\"bottom:133px;left:428px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/24-image-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim\n            .fromTo(cOf(\"24-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"24-line\")[1], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(cOf(\"24-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.75)\n            .fromTo(cOf(\"24-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"24-no\")[0])}}, 1.9)\n            .fromTo(cOf(\"24-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"24-line\")[2], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.35)\n            .fromTo(cOf(\"24-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"24-no\")[1])}}, 2.5)\n            .fromTo(cOf(\"24-image\")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)\n            .fromTo(cOf(\"24-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n          resetNumbers(\"23-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "Bangladesh  Ca m b o d g e  79% 23%  des filles diplômées poursuivent leur éducation ou trouvent du travail la première année après avoir obtenu leur diplôme  réduction du taux d’abandon scolaire des filles dans l’enseignement secondaire, grâce au soutien de Room to Read  D ÉVELOPPEMENT S OC IAL ET ÉC ONOMIQUE DES FEMMES - 23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 25-title\" style=\"top:100px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-title-1.png\">\n        <img class=\"abs halfScaleR 25-line\" style=\"top:241px;left:-537px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-line-1.png\">\n        <img class=\"abs halfScaleR 25-line\" style=\"top:377px;left:-150px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-line-2.png\">\n        <h1 id=\"25-no\" class=\"abs fancyCutMediumStretch 25-no\" style=\"top: 357px; left: 96px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 116000, \"comma\": true}' ></h1>\n        <img class=\"abs halfScale 25-text\" style=\"top:394px;left:86px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-text-1.png\">\n        <img class=\"abs halfScale originBC 25-image\" style=\"bottom:519px;left:37px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-image-1.png\">\n        <h1 id=\"25-no\" class=\"abs fancyCutMediumStretch 25-no\" style=\"top: 341px; left: 425px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 558, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScale 25-text\" style=\"top:735px;left:362px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-text-2.png\">\n        <img class=\"abs halfScale originBC 25-image\" style=\"bottom:147px;left:307px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-image-2.png\">\n        <h1 id=\"25-no\" class=\"abs fancyCutMediumStretch 25-no\" style=\"top: 575px; left: 249px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 135, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScaleC 25-image\" style=\"top:557px;left:68px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-image-3.png\">\n        <img class=\"abs halfScaleC 25-text\" style=\"top:719px;left:48px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-text-3.png\">\n        <img class=\"abs halfScaleC 25-text\" style=\"top:768px;left:-76px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-text-4.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax();\n          pg25Anim\n            .fromTo(cOf(\"25-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"25-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"25-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)\n            .fromTo(cOf(\"25-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[0])}}, 1.6)\n            .fromTo(cOf(\"25-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)\n            .fromTo(cOf(\"25-line\")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"25-image\")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"25-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[1])}}, 2.35)\n            .fromTo(cOf(\"25-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"25-image\")[2], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)\n            .fromTo(cOf(\"25-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[2])}}, 2.8)\n            .fromTo(cOf(\"25-text\")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)\n            .fromTo(cOf(\"25-text\")[3], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)\n        }\n\n        function onPageLeave() {\n          pg25Anim.stop();\n          resetNumbers(\"25-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "OPPORTUNITÉS ÉCONOMIQUES  116 000  558%  Gh a n a  personnes ont accès à l’eau potable grâce aux 317 femmes formées par Saha Global au Ghana  135% Rwanda  20,84 $  46,20 $  augmentation moyenne des revenus mensuels  20,97 $  138,60 $  augmentation moyenne de l’épargne mensuelle  pour les participantes au programme de Women for Women International au Rwanda, entre 2017 et 2020 24 - DÉ V E LO PP EM EN T SO CIA L ET ÉCO N O MIQUE DES FEMMES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleR 26-line\" style=\"top:241px;left:-1252px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-line-1.png\">\n        <img class=\"abs halfScaleR 26-line\" style=\"top:377px;left:-864px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/25-line-2.png\">\n        <img class=\"abs halfScaleR 26-line\" style=\"top:372px;left:-370px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/26-line-3.png\">\n        <img class=\"abs halfScaleR 26-line\" style=\"top:314px;left:348px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/26-line-4.png\">\n        <h1 id=\"26-no\" class=\"abs fancyCutMediumStretch 26-no\" style=\"top: 702px; left: 86px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 253908, \"comma\": true}' ></h1>\n        <h1 id=\"26-no\" class=\"abs fancyCutMediumStretch 26-no\" style=\"top: 702px; left: 236px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 29, \"append\": \"%\"}' ></h1>\n        <h1 id=\"26-no\" class=\"abs fancyCutMediumStretch 26-no\" style=\"top: 756px; left: 526px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 14000, \"comma\": true, \"preppend\": \"+\"}' ></h1>\n        <img class=\"abs halfScale 26-text\" style=\"top:732px;left:72px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/26-text-1.png\">\n        <img class=\"abs halfScale 26-text\" style=\"top:736px;left:229px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/26-text-2.png\">\n        <img class=\"abs halfScale 26-text\" style=\"top:790px;left:518px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/26-text-3.png\">\n        <img class=\"abs halfScaleC 26-image\" style=\"bottom:107px;left:-19px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/26-image-1.png\">\n        <img class=\"abs halfScaleC 26-image\" style=\"bottom:85px;left:220px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/26-image-2.png\">\n        <img class=\"abs halfScaleC 26-image\" style=\"top:550px;left:457px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/26-image-3.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim\n            .fromTo(cOf(\"26-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"26-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"26-line\")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"26-line\")[2], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.35)\n            .fromTo(cOf(\"26-line\")[3], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"26-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.65)\n            .fromTo(cOf(\"26-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"26-no\")[0])}}, 2.8)\n            .fromTo(cOf(\"26-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)\n            .fromTo(cOf(\"26-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"26-no\")[1])}}, 3.1)\n            .fromTo(cOf(\"26-image\")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.25)\n            .fromTo(cOf(\"26-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.4)\n            .fromTo(cOf(\"26-image\")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.55)\n            .fromTo(cOf(\"26-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"26-no\")[2])}}, 3.7)\n            .fromTo(cOf(\"26-text\")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.85)\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n          resetNumbers(\"26-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "AFRIQUE  Ke n ya Éthiopie  253 908 29%  femmes et enfants soutenus par BOMA  augmentation du revenu des femmes ultra-pauvres vivant dans les zones arides du Kenya grâce au programme de réduction de la pauvreté de BOMA  = 500 entreprises  +14 000 entreprises créées  D ÉVELOPPEMENT S OC IAL ET ÉC ONOMIQUE DES FEMMES - 25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "26 - X X X"
  }], [(_ref = {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": ""
  }, defineProperty_default()(_ref, "content", "\n        <img class=\"abs halfScale 28-title\" style=\"top:154px;left:332px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/28-title-1.png\">\n        <img class=\"abs halfScale 28-title\" style=\"top:344px;left:331px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/28-text-1.png\">\n        \n        <div class=\"28-play pointer abs\" onclick=\"Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/Cartier_Sustainable_livelihoods_V4.mp4')\" style=\"top: 275px; left: 563px; filter: invert(1);\">\n          <img class=\"abs halfScaleC halfpulseBig animatedpulse\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/play.png\">\n        </div>\n      "), defineProperty_default()(_ref, "script", "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim\n            .staggerFromTo(cOf(\"28-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"28-play\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n          resetNumbers(\"28-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      "), defineProperty_default()(_ref, "searchText", "MODES DE SUBSISTANCE ET ÉCOSYSTÈMES DURABLES Des inégalités sociales profondes et fortement ancrées freinent le développement de sociétés entières. Au cours de ces dix dernières années, nous avons identifié et financé des approches efficaces dans la lutte contre l’extrême pauvreté. En travaillant aux côtés de petits exploitants agricoles, de communautés pastorales et de micro-entrepreneurs, nos partenaires ont contribué à améliorer leur accès aux ressources, aux informations, aux infrastructures et aux marchés, afin qu’ils deviennent plus productifs et plus résilients face à des conditions environnementales toujours plus instables. XXX - 27"), _ref)], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 29-title\" style=\"top:105px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/29-title-1.png\">\n        <img class=\"abs halfScaleR 29-line\" style=\"top:365px;left:-354px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/29-line-1.png\">\n        <img class=\"abs halfScaleC originBC 29-image\" style=\"bottom:452px;left:138px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/29-image-1.png\">\n        <img class=\"abs halfScaleC originBC 29-image\" style=\"bottom:597px;left:66px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/29-image-2.png\">\n        <h1 id=\"29-no\" class=\"abs fancyCutMediumStretch 29-no\" style=\"top: 276px; left: 100px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 66500, \"preppend\": \"+\", \"comma\": true}' ></h1>\n        <img class=\"abs halfScale 29-text\" style=\"top:313px;left:86px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/29-text-1.png\">\n        <h1 id=\"29-no\" class=\"abs fancyCutMediumStretch 29-no\" style=\"top: 393px; left: 95px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;\"  data-number='{\"to\": 45, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScaleC originBC 29-image\" style=\"bottom:380px;left:-72px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/29-image-3.png\">\n        <img class=\"abs halfScale 29-text\" style=\"top:442px;left:88px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/29-text-2.png\">\n        <img class=\"abs halfScaleC 29-image\" style=\"top:446px;left:-190px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/29-image-4.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim\n            .fromTo(cOf(\"29-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"29-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"29-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)\n            .fromTo(cOf(\"29-image\")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.6)\n            .fromTo(cOf(\"29-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[0])}}, 1.75)\n            .fromTo(cOf(\"29-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"29-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[1])}}, 2.05)\n            .fromTo(cOf(\"29-image\")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"29-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.35)\n            .fromTo(cOf(\"29-image\")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.65)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n          resetNumbers(\"29-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "LES CHEMINS POUR SORTIR DE LA PAUVRETÉ +66 500 micro-entreprises créées en Afrique subsaharienne par Village Enterprise et  45% augmentation du revenu annuel moyen des ménages qui ont pris part au programme de réduction de la pauvreté de Village Enterprise  $  $  AFRIQUE SUBSAHARIENNE  28 - MO DE S D E SUBSISTA N CE ET ÉCO SY STÈ MES DURABLES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleR 30-line\" style=\"top:365px;left:-1068px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/29-line-1.png\">\n        <img class=\"abs halfScaleR 30-line\" style=\"top:321px;left:195px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/30-line-2.png\">\n        <img class=\"abs halfScaleC originBC 30-image\" style=\"bottom:135px;left:2px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/30-image-1.png\">\n        <img class=\"abs halfScaleC originBC 30-image\" style=\"bottom:49px;left:309px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/30-image-2.png\">\n        <h1 id=\"30-no\" class=\"abs fancyCutMediumStretch 30-no\" style=\"top: 598px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3042; padding: 0px; margin: 0px;\"  data-number='{\"to\": 900, \"append\": \"%\", \"comma\": true}' ></h1>\n        <img class=\"abs halfScale 30-text\" style=\"top:631px;left:109px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/30-text-1.png\">\n        <h1 id=\"30-no\" class=\"abs fancyCutMediumStretch 30-no\" style=\"top: 687px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3042; padding: 0px; margin: 0px;\"  data-number='{\"to\": 37, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScale 30-text\" style=\"top:720px;left:108px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/30-text-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim\n            .fromTo(cOf(\"30-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"30-line\")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(cOf(\"30-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"30-no\")[0])}}, 1.75)\n            .fromTo(cOf(\"30-image\")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"30-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"30-image\")[0], 0.6, {x: 30, opacity: 0}, {x: 0, opacity: 1, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"30-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"30-no\")[1])}}, 2.35)\n            .fromTo(cOf(\"30-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n          resetNumbers(\"30-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "900  AFRIQUE  800  700  600  500  400  900%  300  augmentation de l’épargne  37%  200  $  $  O u g a nd a  augmentation des revenus chez les participants au programme de formation des ultra-pauvres de BRAC au Bangladesh, qui est maintenant adapté aux personnes handicapées en Ouganda  100  0  MODES DE S UBS IS TANC E ET ÉC OS YS T ÈMES DURABLES - 29"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 31-title\" style=\"top:105px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/31-title-1.png\">\n\n        <img class=\"abs halfScaleR 31-line\" style=\"top:196px;left:-64px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/31-line-1.png\">\n        <img class=\"abs halfScaleR 31-line\" style=\"top:508px;left:-233px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/31-line-2.png\">\n\n        <img class=\"abs halfScaleC 31-image\" style=\"bottom:370px;left:294px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/31-image-1.png\">\n        <img class=\"abs halfScaleC originBC 31-image\" style=\"bottom:497px;left:23px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/31-image-2.png\">\n        <img class=\"abs halfScaleC originBC 31-image\" style=\"bottom:49px;left:33px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/31-image-3.png\">\n        <img class=\"abs halfScaleC 31-image\" style=\"bottom:-157px;left:359px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/31-image-4.png\">\n\n        <img class=\"abs halfScale 31-text\" style=\"top:237px;left:215px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/31-text-1.png\">\n        <img class=\"abs halfScale 31-text\" style=\"top:337px;left:507px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/31-text-2.png\">\n        <img class=\"abs halfScale 31-text\" style=\"top:648px;left:219px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/31-text-3.png\">\n\n        <h1 id=\"31-no\" class=\"abs fancyCutMediumStretch 31-no\" style=\"top: 202px; left: 224px; font-size: 1.7em; font-weight: 300; color: #1a3142; padding: 0px; margin: 0px;\"  data-number='{\"to\": 221, \"append\": \"%\", \"comma\": true}' ></h1>\n        <h1 id=\"31-no\" class=\"abs fancyCutMediumStretch 31-no\" style=\"top: 614px; left: 225px; font-size: 1.7em; font-weight: 300; color: #1a3142; padding: 0px; margin: 0px;\"  data-number='{\"to\": 20, \"append\": \" \u2013\"}' ></h1>\n        <h1 id=\"31-no\" class=\"abs fancyCutMediumStretch 31-no\" style=\"top: 614px; left: 299px; font-size: 1.7em; font-weight: 300; color: #1a3142; padding: 0px; margin: 0px;\"  data-number='{\"to\": 25, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim\n            .fromTo(cOf(\"31-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"31-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"31-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)\n            .fromTo(cOf(\"31-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(cOf(\"31-image\")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.75)\n            .fromTo(cOf(\"31-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[0])}}, 1.9)\n            .fromTo(cOf(\"31-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"31-line\")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.35)\n            .fromTo(cOf(\"31-image\")[2], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"31-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[1])}}, 2.65)\n            .fromTo(cOf(\"31-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[2])}}, 2.8)\n            .fromTo(cOf(\"31-text\")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)\n            .fromTo(cOf(\"31-image\")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.25)\n        }\n\n        function onPageLeave() {\n          pg31Anim.stop();\n          resetNumbers(\"31-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DES PETITS AGRICULTEURS PLUS FORTS 221%  nourriture supplémentaire produite en 2021 par les agriculteurs soutenus par myAgro  0%  100  Sé n é g a l  $  100 50$  5  Pé rou  35 30 25 20 15 10 5 0  20−25%  croissance annuelle des petites entreprises agricoles soutenues par Root Capital, ce qui a permis d’améliorer les moyens de subsistance des milliers de petits fermiers qui les approvisionnent  30 - MO DE S D E SUBSISTA N CE ET ÉCO SY STÈ MES DURABLES  $  $  255 dollars de gain supplémentaire par agriculteur, soit une augmentation de 46% du revenu moyen"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleR 32-line\" style=\"top:197px;left:-779px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/31-line-1.png\">\n        <img class=\"abs halfScaleR 32-line\" style=\"top:176px;left:221px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/32-line-3.png\">\n        \n        <img class=\"abs halfScaleC 32-image\" style=\"bottom:239px;left:-7px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/32-image-1.png\">\n        <img class=\"abs halfScaleC originBC 32-image\" style=\"bottom:65px;left:204px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/32-image-2.png\">\n        <img class=\"abs halfScaleC originBC 32-image\" style=\"bottom:39px;left:375px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/32-image-3.png\">\n        <img class=\"abs halfScaleC 32-image\" style=\"bottom:27px;left:472px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/32-image-4.png\">\n\n        <img class=\"abs halfScaleR 32-line\" style=\"top:306px;left:-160px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/32-line-2.png\">\n\n        <img class=\"abs halfScale 32-text\" style=\"top:661px;left:94px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/32-text-1.png\">\n        <img class=\"abs halfScale 32-text\" style=\"top:773px;left:94px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/32-text-2.png\">\n        <img class=\"abs halfScale 32-text\" style=\"top:519px;left:429px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/32-text-3.png\">\n\n        <h1 id=\"32-no\" class=\"abs fancyCutMediumStretch 32-no\" style=\"top: 486px; left: 442px; font-size: 1.7em; font-weight: 300; color: #1a3242; padding: 0px; margin: 0px;\"  data-number='{\"to\": 250000, \"comma\": true}' ></h1>\n        <h1 id=\"32-no\" class=\"abs fancyCutMediumStretch 32-no\" style=\"top: 626px; left: 109px; font-size: 1.7em; font-weight: 300; color: #1a3242; padding: 0px; margin: 0px;\"  data-number='{\"to\": 631800, \"comma\": true}' ></h1>\n        <h1 id=\"32-no\" class=\"abs fancyCutMediumStretch 32-no\" style=\"top: 769px; left: 95px; font-size: 1em; font-weight: 300; color: #1a3242; padding: 0px; margin: 0px;\"  data-number='{\"to\": 47, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim\n            .fromTo(cOf(\"32-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"32-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"32-line\")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(cOf(\"32-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[0])}}, 1.75)\n            .fromTo(cOf(\"32-text\")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"32-image\")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"32-image\")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"32-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"32-line\")[2], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.65)\n            .fromTo(cOf(\"32-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[1])}}, 2.8)\n            .fromTo(cOf(\"32-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)\n            .fromTo(cOf(\"32-image\")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.1)\n            .fromTo(cOf(\"32-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.25)\n            .fromTo(cOf(\"32-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[2])}}, 2.8)\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n          resetNumbers(\"32-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "Myanmar  250 000  familles de petits agriculteurs aidées chaque année par Proximity Designs, ce qui a permis un gain net annuel de 300 $ par fermier  Rwanda  631 800  fermiers rwandais ont augmenté leurs revenus de 115 $ en moyenne grâce au soutien de 100 One Acre Fund 10 5  47% augmentation du revenu moyen des agriculteurs soutenus  100 100 100  $  $  $ $ $  $  MODES DE S UBS IS TANC E ET ÉC OS YS T ÈMES DURABLES - 31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 33-title\" style=\"top:100px;left:90px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/33-title-1.png\">\n\n        <img class=\"abs halfScaleC 33-image\" style=\"bottom:178px;left:-193px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/33-image-1.png\">\n        <img class=\"abs halfScaleR 33-line\" style=\"top:422px;left:-244px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/33-line-1.png\">\n\n        <img class=\"abs halfScaleC  33-image\" style=\"bottom:-82px;left:-72px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/33-image-2.png\">\n        <img class=\"abs halfScaleC originBC 33-image\" style=\"bottom:126px;left:250px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/33-image-3.png\">\n\n        <img class=\"abs halfScale 33-text\" style=\"top:704px;left:382px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/33-text-1.png\">\n\n        <h1 id=\"33-no\" class=\"abs fancyCutMediumStretch 33-no\" style=\"top: 649px; left: 390px; font-size: 1.9em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 23, \"append\": \"%\", \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax();\n          pg33Anim\n            .fromTo(cOf(\"33-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"33-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"33-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(cOf(\"33-image\")[1], 0.6, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 1.75)\n            .fromTo(cOf(\"33-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"33-no\")[0])}}, 1.9)\n            .fromTo(cOf(\"33-image\")[2], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"33-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)\n        }\n\n        function onPageLeave() {\n          pg33Anim.stop();\n          resetNumbers(\"33-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "EQUIPÉS POUR PROSPÉRER  Zambie  23% augmentation du revenu des producteurs laitiers de Zambie équipés d’un vélo Buffalo de World Bicycle Relief 32 - MO DE S D E SUBSISTA N CE ET ÉCO SY STÈ MES DURABLES  $  $"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleR 34-line\" style=\"top:422px;left:-958px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/33-line-1.png\">\n        <img class=\"abs halfScaleR 34-line\" style=\"top:187px;left:276px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/34-line-2.png\">\n\n        <img class=\"abs halfScaleC originBC 34-image\" style=\"bottom:49px;left:178px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/34-image-1.png\">\n        <img class=\"abs halfScaleC 34-image\" style=\"bottom:-114px;left:170px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/34-image-2.png\">\n\n        <img class=\"abs halfScale 34-text\" style=\"top:572px;left:70px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/34-text-1.png\">\n        <img class=\"abs halfScale 34-text\" style=\"top:719px;left:70px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/34-text-2.png\">\n\n        <h1 id=\"34-no\" class=\"abs fancyCutMediumStretch 34-no\" style=\"top: 538px; left: 78px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1.9, \"append\": \"M\", \"decimals\": 1}' ></h1>\n        <h1 id=\"34-no\" class=\"abs fancyCutMediumStretch 34-no\" style=\"top: 688px; left: 77px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 22, \"append\": \" \u2013\", \"comma\": true}' ></h1>\n        <h1 id=\"34-no\" class=\"abs fancyCutMediumStretch 34-no\" style=\"top: 688px; left: 151px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 32, \"append\": \"%\", \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim\n            .fromTo(cOf(\"34-line\")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(cOf(\"34-line\")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"34-image\")[1], 0.6, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"34-image\")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"34-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[0])}}, 2.35)\n            .fromTo(cOf(\"34-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"34-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[1])}}, 2.65)\n            .fromTo(cOf(\"34-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[2])}}, 2.8)\n            .fromTo(cOf(\"34-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n          resetNumbers(\"33-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "B a ng l a d e s h  1,9M  Bangladais qui disposent de bas revenus ont reçu de VisionSpring des lunettes de lecture 35 depuis 2006  22−32%  30 25  augmentation de 20 la productivité chez 15 les personnes ayant 10 reçu des lunettes 5 de VisionSpring, démontrée en Inde 0 MODES DE S UBS IS TANC E ET ÉC OS YS T ÈMES DURABLES - 33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "34 - X X X"
  }], [(_ref2 = {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": ""
  }, defineProperty_default()(_ref2, "content", "\n        <img class=\"abs halfScale 36-title\" style=\"top:318px;left:332px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/36-title-1.png\">\n        <img class=\"abs halfScale 36-title\" style=\"top:479px;left:332px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/36-text-1.png\">\n        <div class=\"36-play pointer abs\" onclick=\"Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/Cartier_Philanthropy_Emergency_Response-V12_W_SUBS.mp4')\" style=\"top: 403px; left: 583px; filter: invert(1);\">\n          <img class=\"abs halfScaleC halfpulseBig animatedpulse\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/play.png\">\n        </div>\n      "), defineProperty_default()(_ref2, "script", "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim\n            .staggerFromTo(cOf(\"36-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"36-play\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop();\n          resetNumbers(\"36-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      "), defineProperty_default()(_ref2, "searchText", "RÉPONSE AUX SITUATIONS D’URGENCE Une réponse efficace et opportune aux situations d’urgence peut sauver des vies, soulager les souffrances et protéger les moyens de subsistance. Au cours de la dernière décennie, nos partenaires ont répondu aux crises les plus sévères, s’engageant toujours à restaurer la dignité et à réduire la vulnérabilité des personnes les plus démunies, qui souvent souffrent dans le silence et l’indifférence. XXX - 35"), _ref2)], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 37-title\" style=\"top:105px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/37-title-1.png\">\n\n        <img class=\"abs halfScaleC 37-image\" style=\"bottom:303px;left:-36px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/37-image-1.png\">\n        \n        <img class=\"abs halfScaleR 37-line\" style=\"top:638px;left:-441px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/37-line-1.png\">\n        <img class=\"abs halfScaleR 37-line\" style=\"top:436px;left:-621px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/37-line-2.png\">\n\n        <img class=\"abs halfScale 37-text\" style=\"top:497px;left:115px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/37-text-1.png\">\n        <img class=\"abs halfScale 37-text\" style=\"top:361px;left:320px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/37-text-2.png\">\n\n        <h1 id=\"37-no\" class=\"abs fancyCutMediumStretch 37-no\" style=\"top: 465px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 8, \"append\": \"\", \"comma\": true}' ></h1>\n        <h1 id=\"37-no\" class=\"abs fancyCutMediumStretch 37-no\" style=\"top: 328px; left: 330px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 34500, \"preppend\": \"+\", \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax();\n          pg37Anim\n            .fromTo(cOf(\"37-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"37-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"37-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"37-no\")[0])}}, 1.6)\n            .fromTo(cOf(\"37-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"37-no\")[1])}}, 1.9)\n            .fromTo(cOf(\"37-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)\n            .fromTo(cOf(\"37-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"37-line\")[0], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"37-line\")[1], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)\n        }\n\n        function onPageLeave() {\n          pg37Anim.stop();\n          resetNumbers(\"37-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "MIGRATION ET DÉPLACEMENTS  +34 500  survivants secourus en Méditerranée centrale depuis 2016 grâce à SOS Méditerranée  8  camps de réfugiés démantelés en Haïti entre 2013 et 2017 grâce à CARE qui a permis aux personnes de trouver un endroit adéquat pour vivre  2012  2013  36 - RÉ P O N S E A UX SITUATIO N S D ’ UR GEN CE  2014  2015  2016  2017"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 38-image\" style=\"bottom:452px;left:-15px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/38-image-1.png\">\n        <img class=\"abs halfScaleC 38-image\" style=\"bottom:527px;left:306px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/38-image-2.png\">\n        <img class=\"abs halfScaleC 38-image\" style=\"bottom:179px;left:270px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/38-image-3.png\">\n        <img class=\"abs halfScaleC 38-image\" style=\"bottom:425px;left:422px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/38-image-4.png\">\n        <img class=\"abs halfScaleC 38-image\" style=\"bottom:334px;left:452px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/38-image-5.png\">\n        \n        <img class=\"abs halfScaleR 38-line\" style=\"top:436px;left:-1335px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/37-line-2.png\">\n        <img class=\"abs halfScaleR 38-line\" style=\"top:177px;left:-150px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/38-line-1.png\">\n        <img class=\"abs halfScaleR 38-line\" style=\"top:313px;left:231px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/38-line-2.png\">\n        <img class=\"abs halfScaleR 38-line\" style=\"top:619px;left:423px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/38-line-3.png\">\n\n        <img class=\"abs halfScale 38-text\" style=\"top:390px;left:69px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/38-text-1.png\">\n        <img class=\"abs halfScale 38-text\" style=\"top:340px;left:336px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/38-text-2.png\">\n        <img class=\"abs halfScale 38-text\" style=\"top:524px;left:496px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/38-text-3.png\">\n\n        <h1 id=\"38-no\" class=\"abs fancyCutMediumStretch 38-no\" style=\"top: 356px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 340000, \"append\": \"\", \"comma\": true}' ></h1>\n        <h1 id=\"38-no\" class=\"abs fancyCutMediumStretch 38-no\" style=\"top: 306px; left: 347px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10000, \"preppend\": \"+\", \"comma\": true}' ></h1>\n        <h1 id=\"38-no\" class=\"abs fancyCutMediumStretch 38-no\" style=\"top: 486px; left: 509px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 200000, \"append\": \"\", \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim\n            .fromTo(cOf(\"38-line\")[0], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"38-line\")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.2)\n            .fromTo(cOf(\"38-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.35)\n            .fromTo(cOf(\"38-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"38-no\")[0])}}, 2.5)\n            .fromTo(cOf(\"38-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.65)\n            .fromTo(cOf(\"38-line\")[2], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"38-image\")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.65)\n            .fromTo(cOf(\"38-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"38-no\")[1])}}, 2.8)\n            .fromTo(cOf(\"38-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)\n            .fromTo(cOf(\"38-image\")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.1)\n            .fromTo(cOf(\"38-line\")[3], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.8)\n            .fromTo(cOf(\"38-image\")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.95)\n            .fromTo(cOf(\"38-image\")[4], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.1)\n            .fromTo(cOf(\"38-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"38-no\")[2])}}, 3.25)\n            .fromTo(cOf(\"38-text\")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.4)\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop();\n          resetNumbers(\"38-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "+10 000  Afghans ont pris un nouveau départ aux États-Unis avec l’aide de l’International Rescue Committee  340 000  réfugiés Rohingyas ont bénéficié de services de santé de qualité à Cox’s Bazar grâce à Médecins Sans Frontières en 2018 et à BRAC en 2019 et 2020  2018  2019  200 000 personnes assistées en Ukraine et hors des frontières par Medair  2020  2021  2022  RÉPONS E AUX S IT UAT IONS D’URG ENC E - 37"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 39-title\" style=\"top:105px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/39-title-1.png\">\n        <img class=\"abs halfScale 39-title\" style=\"top:552px;left:242px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/39-text-1.png\">\n        <img class=\"abs halfScale 39-title\" style=\"top:717px;left:406px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/39-text-2.png\">\n\n        <img class=\"abs halfScaleC 39-image\" style=\"bottom:359px;left:203px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/39-image-1.png\">\n        <img class=\"abs halfScaleC 39-image\" style=\"bottom:254px;left:35px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/39-image-2.png\">\n        <img class=\"abs halfScaleC 39-image\" style=\"bottom:103px;left:144px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/39-image-3.png\">\n        \n        <h1 id=\"39-no\" class=\"abs fancyCutMediumStretch 39-no\" style=\"top: 485px; left: 260px; font-size: 3.6em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 4.3, \"append\": \"M\", \"decimals\": 1}' ></h1>\n        <h1 id=\"39-no\" class=\"abs fancyCutMediumStretch 39-no\" style=\"top: 648px; left: 412px; font-size: 3.6em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 21, \"preppend\": \"\", \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim\n            .fromTo(cOf(\"39-title\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .staggerFromTo(cOf(\"39-image\"), 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 0.3, 1.3)\n            .fromTo(cOf(\"39-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"39-no\")[0])}}, 1.75)\n            .fromTo(cOf(\"39-title\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"39-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"39-no\")[1])}}, 2.05)\n            .fromTo(cOf(\"39-title\")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)\n        }\n\n        function onPageLeave() {\n          pg39Anim.stop();\n          resetNumbers(\"39-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "PANDÉMIE DE CORONAVIRUS 2020-2022  4,3M  D E F RA NCS S UI S S E S  21  PAY S  38 - RÉ P O N S E A UX SITUATIO N S D ’ UR GEN CE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 40-title\" style=\"top:698px;left:244px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/40-text-1.png\">\n\n        <img class=\"abs halfScaleC 40-image\" style=\"bottom:515px;left:-27px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/40-image-1.png\">\n        <img class=\"abs halfScaleC 40-image\" style=\"bottom:457px;left:172px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/40-image-2.png\">\n        <img class=\"abs halfScaleC 40-image\" style=\"bottom:277px;left:-7px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/40-image-3.png\">\n        <img class=\"abs halfScaleC 40-image\" style=\"bottom:233px;left:194px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/40-image-4.png\">\n        <img class=\"abs halfScaleC 40-image\" style=\"bottom:93px;left:39px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/40-image-5.png\">\n        \n        <h1 id=\"40-no\" class=\"abs fancyCutMediumStretch 40-no\" style=\"top: 628px; left: 252px; font-size: 3.6em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 20, \"preppend\": \"\", \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim\n            .staggerFromTo(cOf(\"40-image\"), 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 0.3, 1.3)\n            .fromTo(cOf(\"40-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"40-no\")[0])}}, 2.65)\n            .fromTo(cOf(\"40-title\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n          resetNumbers(\"40-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "20  O R GA NI S ATI ONS  RÉPONS E AUX S IT UAT IONS D’URG ENC E - 39"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs\" style=\"top: 478px; left: 555px; width: 25px; height: 24px; background: white;\"></div>\n\n        <img class=\"abs halfScale 41-title\" style=\"top:105px;left:89px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/41-title-1.png\">\n\n        <img class=\"abs halfScaleC 41-image\" style=\"bottom:576px;left:397px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/41-image-1.png\">\n        <img class=\"abs halfScaleC 41-image\" style=\"bottom:35px;left:367px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/41-image-2.png\">\n        \n        <img class=\"abs halfScaleR 41-line\" style=\"top:372px;left:-12px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/41-line-1.png\">\n        <img class=\"abs halfScaleR 41-line\" style=\"top:315px;left:99px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/41-line-2.png\">\n\n        <img class=\"abs halfScale 41-text\" style=\"top:402px;left:88px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/41-text-1.png\">\n\n        <h1 id=\"41-no\" class=\"abs fancyCutMediumStretch 41-no\" style=\"top: 369px; left: 103px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 200000, \"comma\": true}' ></h1>\n        <h1 id=\"41-no\" class=\"abs fancyCutMediumStretch 41-no\" style=\"top: 270px; left: 426px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2.8, \"append\": \"M\", \"decimals\": 1}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim\n            .fromTo(cOf(\"41-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"41-line\")[0], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"41-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"41-no\")[0])}}, 1.45)\n            .fromTo(cOf(\"41-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(cOf(\"41-line\")[1], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.9)\n            .fromTo(cOf(\"41-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.05)\n            .fromTo(cOf(\"41-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"41-no\")[1])}}, 2.2)\n            .fromTo(cOf(\"41-image\")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.35)\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n          resetNumbers(\"41-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "CATASTROPHES NATURELLES 2,8M 200 000  Népalais ont reçu de la nourriture de la Fédération internationale de la Croix-Rouge après le séisme de 2015  Philippins ont bénéficié d’eau potable et d’installations sanitaires grâce à Action contre la Faim après le passage du typhon Haiyan  2012  2013  40 - RÉ P O N S E A UX SITUATIO N S D ’ UR GEN CE  2014  2015  2016  2017"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 42-image\" style=\"bottom:578px;left:41px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/42-image-1.png\">\n        <img class=\"abs halfScaleC 42-image\" style=\"bottom:419px;left:316px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/42-image-2.png\">\n        \n        <img class=\"abs halfScaleR 42-line\" style=\"top:215px;left:-195px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/42-line-1.png\">\n        <img class=\"abs halfScaleR 42-line\" style=\"top:126px;left:229px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/42-line-2.png\">\n        <img class=\"abs halfScaleR 42-line\" style=\"top:313px;left:360px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/42-line-3.png\">\n\n        <img class=\"abs halfScale 42-text\" style=\"top:247px;left:119px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/42-text-1.png\">\n        <img class=\"abs halfScale 42-text\" style=\"top:460px;left:119px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/42-text-2.png\">\n        <img class=\"abs halfScale 42-text\" style=\"top:163px;left:335px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/42-text-3.png\">\n        <img class=\"abs halfScale 42-text\" style=\"top:434px;left:407px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/42-text-4.png\">\n        <img class=\"abs halfScale 42-text\" style=\"top:602px;left:408px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/42-text-5.png\">\n\n        <h1 id=\"42-no\" class=\"abs fancyCutMediumStretch 42-no\" style=\"top: 214px; left: 132px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 20900, \"comma\": true}' ></h1>\n        <h1 id=\"42-no\" class=\"abs fancyCutMediumStretch 42-no\" style=\"top: 427px; left: 132px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 127500, \"comma\": true}' ></h1>\n        <h1 id=\"42-no\" class=\"abs fancyCutMediumStretch 42-no\" style=\"top: 128px; left: 348px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50000, \"comma\": true}' ></h1>\n        <h1 id=\"42-no\" class=\"abs fancyCutMediumStretch 42-no\" style=\"top: 397px; left: 418px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10000, \"comma\": true}' ></h1>\n        <h1 id=\"42-no\" class=\"abs fancyCutMediumStretch 42-no\" style=\"top: 569px; left: 418px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2000, \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim\n            .fromTo(cOf(\"42-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"42-line\")[0], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.5)\n            .fromTo(cOf(\"42-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"42-no\")[0])}}, 2.65)\n            .fromTo(cOf(\"42-text\")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)\n            .fromTo(cOf(\"42-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"42-no\")[1])}}, 2.95)\n            .fromTo(cOf(\"42-text\")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)\n            .fromTo(cOf(\"42-line\")[1], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 3.4)\n            .fromTo(cOf(\"42-image\")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.55)\n            .fromTo(cOf(\"42-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"42-no\")[2])}}, 3.7)\n            .fromTo(cOf(\"42-text\")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.85)\n            .fromTo(cOf(\"42-line\")[2], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 4.15)\n            .fromTo(cOf(\"42-image\")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 4.3)\n            .fromTo(cOf(\"42-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"42-no\")[3])}}, 4.45)\n            .fromTo(cOf(\"42-text\")[3], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 4.6)\n            .fromTo(cOf(\"42-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"42-no\")[4])}}, 4.75)\n            .fromTo(cOf(\"42-text\")[4], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 4.9)\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop();\n          resetNumbers(\"42-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "50 000 20 900  enfants traités par le programme d’alimentation ambulatoire de Médecins Sans Frontières dans l’unité pédiatrique de l’hôpital de Magaria, au Niger  127 500  enfants de moins de cinq ans examinés pour détecter et traiter la malnutrition  familles ont bénéficié d’une aide d’urgence et de différentes mesures de redressement mises en place par BRAC après des inondations sans précédent  10 000  personnes ont reçu une aide alimentaire d’urgence par Medair dans le district de Beloha, à Madagascar  2 000  enfants de moins de cinq ans examinés pour détecter de la malnutrition  = 100 enfants de moins de cinq ans  2018  2019  2020  2021  2022  RÉPONS E AUX S IT UAT IONS D’URG ENC E - 41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "42 - A XX CCE X S S TO B A SIC SER VICES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 44-title\" style=\"top:150px;left:333px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/44-title-1.png\">\n        <img class=\"abs halfScale 44-title\" style=\"top:318px;left:333px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/44-title-2.png\">\n        <img class=\"abs halfScale 44-title\" style=\"top:424px;left:355px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/44-text-1.png\">\n        <img class=\"abs halfScale 44-title\" style=\"top:474px;left:356px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/44-text-2.png\">\n        <img class=\"abs halfScale 44-title\" style=\"top:548px;left:356px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/44-text-3.png\">\n        <img class=\"abs halfScale 44-title\" style=\"top:674px;left:356px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/44-text-4.png\">\n        <img class=\"abs halfScale 44-title\" style=\"top:768px;left:356px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/44-text-5.png\">\n\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(44);\" style=\"top: 419px; left: 351px; width: 305px; height: 24px;\"></div>\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(46);\" style=\"top: 473px; left: 351px; width: 305px; height: 41px;\"></div>\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(48);\" style=\"top: 545px; left: 351px; width: 305px; height: 97px;\"></div>\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(50);\" style=\"top: 673px; left: 351px; width: 305px; height: 49px;\"></div>\n        <div class=\"contentLinkNone\" onclick=\"Publish.goToPage(52);\" style=\"top: 764px; left: 351px; width: 305px; height: 59px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg44Anim = new TimelineMax();\n          pg44Anim\n            .staggerFromTo(cOf(\"44-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg44Anim.stop();\n          resetNumbers(\"43-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "LES CINQ LEÇONS TIRÉES D’UNE DÉCENNIE D’ENGAGEMENT 1.  FINANCER L’IMPACT 2. UN FINANCEMENT À LONG TERME ET SANS RESTRICTION 3. INNOVER C’EST BIEN, MAIS RENDRE ACCESSIBLES AU PLUS GRAND NOMBRE DES SOLUTIONS ÉPROUVÉES C’EST ENCORE MIEUX 4. TROUVER LE BON ÉQUILIBRE DANS LA DYNAMIQUE DU POUVOIR 5. S’ENGAGER SUR DES RÉSULTATS ET ASSUMER SES RESPONSABILITÉS XXX - 43"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 45-title\" style=\"top:664px;left:84px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/45-title-1.png\">\n        <img class=\"abs halfScale 45-title\" style=\"top:720px;left:85px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/45-text-1.png\">\n        <img class=\"abs halfScale 45-title\" style=\"top:759px;left:85px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/45-text-2.png\">\n\n        <h1 id=\"45-no\" class=\"abs fancyCutBold 45-no\" style=\"top: 384px; left: 548px; font-size: 2.1em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;\"  data-number='{\"to\": 40, \"append\": \"%\"}' ></h1>\n        <h1 id=\"45-no\" class=\"abs fancyCutBold 45-no\" style=\"top: 415px; left: 556px; font-size: 2.1em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;\"  data-number='{\"to\": 0.8, \"append\": \"%\", \"decimals\": 1}' ></h1>\n\n        <div class=\"contentLinkNone abs\" style=\"top: 660px; left: 79px; width: 565px; height: 165px;\" onclick=\"Publish.openArticle(2)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax();\n          pg45Anim\n            .staggerFromTo(cOf(\"45-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"45-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"45-no\")[0])}}, 1.3)\n            .fromTo(cOf(\"45-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"45-no\")[1])}}, 1.6)\n        }\n\n        function onPageLeave() {\n          pg45Anim.stop();\n          resetNumbers(\"45-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "Réduction du taux de transmission du VIH de la mère à l’enfant de  40% à 0,8%  1. FINANCER L’IMPACT Il y a tant à faire aujourd’hui - et les besoins sont si urgents - que nous ne pouvons pas nous permettre de gaspiller de l’argent, du temps ou de l’énergie sur des programmes qui ne fonctionnent pas. Notre première responsabilité, en tant que bailleur, est de nous assurer que chaque dollar investi apporte un changement positif, concret et tangible dans la vie des personnes pour lesquelles nous nous engageons. Pour ce faire, nous devons soutenir des solutions éprouvées, étayées par des données probantes, et qui auront des résultats impactants. 44 - LE S CI N Q L EÇO N S TIR ÉES D ’ UN E D ÉCE NNIE D’ENG AG EMENT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"46-no\" class=\"abs fancyCutBold 46-no\" style=\"top: 211px; left: 550px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;\"  data-number='{\"to\": 75, \"append\": \"%\"}' ></h1>\n        <div class=\"contentLinkNone abs\" style=\"    top: 406px; left: 62px; width: 569px; height: 418px;\" onclick=\"Publish.openArticle(2)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg46Anim = new TimelineMax();\n          pg46Anim\n            .fromTo(cOf(\"46-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"46-no\")[0])}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg46Anim.stop();\n          resetNumbers(\"46-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "75%  des élèves sont toujours scolarisés six ans plus tard  mothers2mothers  The Luminos Fund  mothers2mothers (m2m) emploie des femmes vivant avec le VIH-SIDA afin qu’elles facilitent l’accès d’autres femmes et de leur famille aux services essentiels et aux soins de santé. Le programme se concentre sur la réduction du risque d’infection au VIH et aux maladies associées. Depuis 2017, notre soutien a permis à m2m de déployer ses services de santé intégrée en Ouganda pour réduire la transmission du virus des femmes enceintes et séropositives à leur bébé et pour préserver plus en général la santé des femmes et des enfants.  Le programme d’apprentissage accéléré de Luminos Fund, « Seconde Chance », a déjà permis à plus de 152 000 enfants africains, qui n’ont jamais été scolarisés ou qui ont dû interrompre leur éducation à cause de la pauvreté, d’un conflit ou de la discrimination, de retrouver les bancs de l’école. Depuis 2018, nous soutenons l’expansion rapide du programme dans les régions reculées d’Afar et d’Oromia, en Éthiopie.  Pays : Ouganda Financé depuis 2017  Pays : Éthiopie Financé depuis 2018  Au cours de ces vingt dernières années, les efforts de m2m ont permis l’élimination presque totale de la transmission du virus de la mère à l’enfant parmi les femmes encadrées par son programme : en Afrique orientale et australe, le taux de transmission du VIH de ces femmes à leur enfant est passé de 40 % à 0,8 % et la mortalité infantile a été abaissée à deux décès pour 1 000 naissances.  Parmi les 26 850 élèves inscrits dans les classes de « Seconde Chance », entre 2018 et 2021, 91 % à 97 % d’entre eux ont réussi leur transition vers des écoles publiques et poursuivent leur éducation. Quelque 9 000 enfants supplémentaires ont bénéficié du programme mis en œuvre directement par le gouvernement. Six ans plus tard, 75 % des élèves de « Seconde Chance » sont toujours scolarisés.  L ES CINQ LEÇ ONS T IRÉES D’UNE DÉC ENNIE D’ENG AG EMENT - 45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 47-title\" style=\"top:590px;left:84px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/47-title-1.png\">\n        <img class=\"abs halfScale 47-title\" style=\"top:691px;left:85px;transform:scale(0.525)\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/47-text-1.png\">\n        <div class=\"contentLinkNone abs\" style=\"top: 592px; left: 79px; width: 594px; height: 236px;\" onclick=\"Publish.openArticle(3)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim\n            .staggerFromTo(cOf(\"47-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg47Anim.stop();\n          resetNumbers(\"47-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "2. UN FINANCEMENT À LONG TERME ET SANS RESTRICTION Nous travaillons sur des questions très complexes et multidimensionnelles et, à ce titre, nous ne nous attendons pas à des résultats immédiats, d’un jour à l’autre. Notre engagement se fait sur le long terme. Soutenir des projets sur deux ou trois ans seulement reviendrait à choisir une approche de type « cases à cocher ». Nous avons fait le choix d’investir sur le long terme et sur la création d’alliances solides, en aidant nos partenaires à se développer, à renforcer leur impact et à élargir le champ de leurs opérations. Fournir un financement sans restriction, que les organisations à but non lucratif gèrent comme elles l’entendent, est sûrement la mesure la plus transformatrice que nous puissions prendre pour véritablement les aider à atteindre leurs objectifs. 46 - LE S CI N Q L EÇO N S TIR ÉES D ’ UN E D ÉCE NNIE D’ENG AG EMENT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"48-no\" class=\"abs fancyCutBold 48-no\" style=\"top: 261px; left: 563px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2.8, \"preppend\": \"+\", \"append\": \"M\", \"decimals\": 1}' ></h1>\n        <div class=\"contentLinkNone abs\" style=\"    top: 395px; left: 62px; width: 569px; height: 429px;\" onclick=\"Publish.openArticle(3)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim\n            .fromTo(cOf(\"48-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"48-no\")[0])}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n          resetNumbers(\"48-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "+2,8M filles soutenues dans le monde  Educate Girls  Room to Read  Pays : Inde Financé depuis 2014  Pays : Bangladesh, Cambodge, sans restriction Financé depuis 2019  Educate Girls s’attaque aux inégalités entre les sexes et aux barrières qui empêchent les filles d’aller à l’école dans les villages ruraux les plus isolés de l’Inde. Partant d’un projet pilote portant sur 50 écoles en 2007, Educate Girls couvre aujourd’hui plus de 20 000 villages au Rajasthan, au Madhya Pradesh et en Uttar Pradesh. Au fil des ans, Educate Girls a obtenu des résultats impressionnants en matière d’inscription, de rétention et d’apprentissage. Les visites à domicile et la sensibilisation des communautés sont au cœur de son succès. Educate Girls exploite également les ressources gouvernementales pour améliorer les infrastructures, la gouvernance et l’enseignement des écoles publiques. Nous finançons l’approche unique d’Educate Girls depuis 2014, contribuant à la scolarisation de plus de 1,1 million de filles. Aujourd’hui, nous soutenons l’organisation pour qu’elle touche 1,5 million de filles d’ici 2024.  Room to Read cherche à transformer la vie de millions d’enfants vivant dans des communautés à faible revenu en se concentrant sur l’alphabétisation et l’égalité des genres dans l’éducation. En collaborant avec les communautés locales, les gouvernements et des organisations partenaires, Room to Read développe l’alphabétisation et inculque l’habitude de la lecture aux enfants des écoles primaires. Depuis 2019, nous soutenons son Programme d’éducation pour les filles au Bangladesh et au Cambodge, permettant aux adolescentes d’acquérir et de mettre en pratique - par des cours, des ateliers et des activités extrascolaires des connaissances et des compétences de vie afin qu’elles puissent poursuivre leurs études et prendre des décisions éclairées pour leur futur. Depuis juillet 2022, nous offrons à l’organisation un soutien financier sans restriction.  L ES CINQ LEÇ ONS T IRÉES D’UNE DÉC ENNIE D’ENG AG EMENT - 47"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 49-title\" style=\"top:517px;left:84px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/49-title-1.png\">\n        <img class=\"abs halfScale 49-title\" style=\"top:743px;left:85px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/49-text-1.png\">\n\n        <h1 id=\"49-no\" class=\"abs fancyCutBold 49-no\" style=\"top: 364px; left: 507px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;\"  data-number='{\"to\": 160000, \"comma\": true}' ></h1>\n        <div class=\"contentLinkNone abs\" style=\"top: 509px; left: 79px; width: 578px; height: 317px;\" onclick=\"Publish.openArticle(4)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax();\n          pg49Anim\n            .staggerFromTo(cOf(\"49-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"49-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[0])}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg49Anim.stop();\n          resetNumbers(\"49-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "160 000 femmes souffrant de dépression traitées en Ouganda et en Zambie  3. INNOVER C’EST BIEN, MAIS RENDRE ACCESSIBLES AU PLUS GRAND NOMBRE DES SOLUTIONS ÉPROUVÉES C’EST ENCORE MIEUX Au vu de l’urgence et de l’intensité des problèmes sociaux actuels, si l’ensemble de la communauté philanthropique est séduite par l’innovation et se concentre uniquement sur celle-ci, nous ne serons jamais en mesure de rendre accessibles au plus grand nombre les solutions qui fonctionnent déjà. En d’autres termes, nous n’avons pas besoin d’un million d’innovations, mais d’une seule qui fonctionne, répliquée un million de fois, afin que son impact soit à la hauteur des besoins. 48 - LE S CI N Q L EÇO N S TIR ÉES D ’ UN E D ÉCE NNIE D’ENG AG EMENT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"50-no\" class=\"abs fancyCutBold 50-no\" style=\"top: 139px; left: 279px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;\"  data-number='{\"to\": 38, \"append\": \"%\"}' ></h1>\n        <div class=\"contentLinkNone abs\" style=\"    top: 477px; left: 62px; width: 569px; height: 346px;\" onclick=\"Publish.openArticle(4)\"></div>\n        <div class=\"contentLinkNone abs\" style=\"top: 274px; left: 62px; width: 289px; height: 203px;\" onclick=\"Publish.openArticle(4)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax();\n          pg50Anim\n            .fromTo(cOf(\"50-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"50-no\")[0])}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg50Anim.stop();\n          resetNumbers(\"50-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "38%  réduction de la morbidité des élèves dans les écoles  StrongMinds  Pays : Ouganda, Zambie Financé depuis 2018  L’OMS promeut les thérapies de groupe en tant qu’intervention de santé mentale de première ligne pour les populations vulnérables. StrongMinds est la seule organisation à mettre en œuvre cette solution efficace pour lutter contre la dépression en Afrique. StrongMinds forme et supervise des agents communautaires pour qu’ils deviennent des animateurs en santé mentale chargés d’encadrer des groupes de parole. Ces thérapies ciblent les femmes souffrant de dépression au sein des communautés défavorisées, où la prévalence de la dépression, avec un taux affichant 25 %, est très présente. Des groupes de 10 à 15 femmes se réunissent pour des séances hebdomadaires de 90 minutes, où elles apprennent à identifier les déclencheurs de la dépression, elles partagent des stratégies permettant de combattre les symptômes et, à plus long terme, elles apprennent à devenir plus résilientes. StrongMinds permet ensuite aux femmes arrivées au terme du programme de se former pour encadrer leurs propres groupes de parole, ce qui amplifie l’impact du programme sur le long terme. Nous soutenons StrongMinds depuis 2018 afin que l’organisation développe en Zambie le modèle mis en place en Ouganda. L’organisation est désormais devenue conseillère technique du ministère zambien de la Santé en matière de santé mentale.  Healthy Learners Pays : Zambie Financé depuis 2019  Healthy Learners s’engage à améliorer la santé des enfants de plus de cinq ans grâce à son programme de santé communautaire en milieu scolaire. L’organisation forme les enseignants à reconnaître les symptômes des maladies courantes chez les élèves et à leur prodiguer les soins de base ou à les référer à des centres de santé. Plus vite l’enfant malade est identifié et soigné, plus vite il reprendra l’école. Depuis le début de notre collaboration en 2019, Healthy Learners a systématisé son programme et renforcé sa collaboration avec les ministères zambiens de la Santé et de l’Éducation pour inscrire ce dispositif dans la stratégie nationale de santé scolaire.  L ES CINQ LEÇ ONS T IRÉES D’UNE DÉC ENNIE D’ENG AG EMENT - 49"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 51-title\" style=\"top:505px;left:85px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/51-title-1.png\">\n        <img class=\"abs halfScale 51-title\" style=\"top:646px;left:85px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/51-text-1.png\">\n        <div class=\"contentLinkNone abs\" style=\"    top: 501px; left: 79px; width: 575px; height: 327px;\" onclick=\"Publish.openArticle(5)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg51Anim = new TimelineMax();\n          pg51Anim\n            .staggerFromTo(cOf(\"51-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg51Anim.stop();\n          resetNumbers(\"51-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "4. TROUVER LE BON ÉQUILIBRE DANS LA DYNAMIQUE DU POUVOIR Lorsqu’il est question de modifier ou d’améliorer les pratiques philanthropiques, la responsabilité incombe aux bailleurs. La dynamique du pouvoir exige que les bailleurs eux-mêmes remettent en question la nature de leurs relations avec les organisations financées. Il faut donc avant tout reconnaître l’existence d’un déséquilibre de pouvoir qui peut empêcher, s’il n’est pas assumé, une collaboration honnête et fructueuse. Nos partenaires attendent de nous que nous soyons flexibles, pragmatiques, à l’écoute de leurs besoins et de leurs difficultés et prêts à amplifier et à faire connaître leur travail. Mais avant toute chose, ils ont besoin de notre confiance. Ces dernières années, nous avons intentionnellement créé des occasions d’échanges avec nos partenaires afin qu’ils puissent librement exprimer leurs doutes, remettre en question nos demandes ou exposer les changements de stratégie envisagés. Favoriser ainsi le dialogue a permis d’établir des relations de confiance, qui sont à la base des progrès réalisés ensemble. 50 - LE S CI N Q L EÇO N S TIR ÉES D ’ UN E D ÉCE NNIE D’ENG AG EMENT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"52-no\" class=\"abs fancyCutBold 52-no\" style=\"top: 87px; left: 267px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;\"  data-number='{\"to\": 9000, \"preppend\": \"+\", \"comma\": true}' ></h1>\n        <div class=\"contentLinkNone abs\" style=\"top: 375px; left: 62px; width: 569px; height: 452px;\" onclick=\"Publish.openArticle(5)\"></div>\n        <div class=\"contentLinkNone abs\" style=\"    top: 209px; left: 352px; width: 289px; height: 167px;\" onclick=\"Publish.openArticle(5)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg52Anim = new TimelineMax();\n          pg52Anim\n            .fromTo(cOf(\"52-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"52-no\")[0])}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg52Anim.stop();\n          resetNumbers(\"52-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "+9 000 communautés engagées à mettre fin au mariage des enfants  Tostan  Pays : Gambie, Guinéee-Bissau et Sénégal Financé depuis 2016  Village Enterprise Pays : Ouganda Financé depuis 2016  Le programme de formation de Village Enterprise vient en aide aux personnes vivant dans l’extrême pauvreté, en leur permettant de développer des moyens de subsistance durables. L’organisation fournit aux participants une aide financière, une formation en entrepreneuriat et en finance, ainsi qu’un mentorat continu pour les aider à créer des micro-entreprises de trois personnes et à constituer des groupes d’épargne. Nous soutenons Village Enterprise en Ouganda, où l’organisation est active depuis 2016. Aujourd’hui, ses activités s’étendent dans plusieurs pays d’Afrique subsaharienne et ont pour objectif de permettre à plus de 20 millions de personnes d’échapper à la pauvreté d’ici 2030. Notre collaboration avec Village Enterprise n’a eu de cesse d’évoluer ces dernières années jusqu’à devenir un partenariat solide, axé sur le dialogue, la transparence et la confiance. En plus d’un soutien financier flexible, nous sommes fiers de les accompagner dans leurs discussions stratégiques et de les soutenir activement dans leurs démarches de recherche de financements supplémentaires.  Tostan a mis sur pied un modèle participatif sur trois ans qui permet aux jeunes, aux adultes, aux personnes âgées et aux leaders communautaires de se former aux droits de l’homme, à l’hygiène et à la santé, à la résolution de conflits, à l’autonomie économique et à l’éducation des enfants. Le programme aborde aussi des notions élémentaires de lecture, d’écriture et de calcul. Ce modèle de développement communautaire favorise le changement social et comportemental, en encourageant les villageois à remettre en question des pratiques dangereuses profondément ancrées. L’un des succès de Tostan est l’engagement de plus de 9 000 communautés à mettre fin au mariage des enfants et à l’excision. Nous soutenons Tostan au Sénégal depuis 2018 ; aujourd’hui nous finançons l’organisation pour qu’elle puisse toucher plus de 107 500 personnes vivant dans des communautés reculées en Gambie, au Sénégal et en Guinée-Bissau. Notre partenariat avec Tostan grandit et se révèle toujours plus authentique et pertinent année après année. Elena Bonometti, directrice de Tostan, parle d’une relation « transformative » avec Cartier Philanthropy, qui nous pousse ensemble à nous remettre en question et à être lucides face aux défis auxquels nous sommes confrontés et aux attentes qu’ils suscitent. Notre relation en sort renforcée et entièrement dédiée aux communautés que nous servons.  L ES C INQ LEÇ ONS T IRÉES D’UNE DÉC ENNIE D’ENG AG EMENT - 51"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 53-title\" style=\"top:552px;left:84px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/53-title-1.png\">\n        <img class=\"abs halfScale 53-title\" style=\"top:694px;left:85px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/53-text-1.png\">\n        <div class=\"contentLinkNone abs\" style=\"top: 549px; left: 79px; width: 575px; height: 278px;\" onclick=\"Publish.openArticle(6)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg53Anim = new TimelineMax();\n          pg53Anim\n            .staggerFromTo(cOf(\"53-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg53Anim.stop();\n          resetNumbers(\"53-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "Buildher, Kheyti, Healthy Learners et Proximity Designs ont été soutenus jusqu’à aujourd’hui  5. S’ENGAGER SUR DES RÉSULTATS ET ASSUMER SES RESPONSABILITÉS Nous œuvrons dans un secteur où nous pouvons librement choisir quelle voie prendre. Nous définissons notre mission et notre vision et nous sélectionnons nos partenaires selon nos propres critères. Nous décidons de ce que nous allons considérer comme un succès ou un échec. Si nous voulons être vraiment sincères en matière de progrès et d’impact social, il nous faut alors évaluer les résultats sur la base de données rigoureuses et les assumer à travers une communication publique. Il nous semble important de révéler de manière transparente les résultats que nous attendons et les objectifs fixés. De même que nous célébrerons nos succès, il est également de notre devoir d’admettre et de partager nos échecs afin d’en tirer des leçons utiles pour tous. 52 - LE S CI N Q L EÇO N S TIR ÉES D ’ UN E D ÉCE NNIE D’ENG AG EMENT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLinkNone abs\" style=\"    top: 301px; left: 62px; width: 569px; height: 525px;\" onclick=\"Publish.openArticle(6)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IDinsight  Pays : Inde, Kenya, Myanmar, Zambie Financé depuis 2020  Les organisations à but non lucratif fournissent des services essentiels aux populations les plus pauvres du monde. Cette mission cruciale nécessite de disposer de données probantes pour optimiser la conception des programmes, améliorer leur mise en œuvre et maximiser leur impact. IDinsight est une organisation internationale de conseil, d’analyse de données et de recherche qui accompagne les leaders du développement à produire et à utiliser des données dans leur prise de décision. Nous soutenons depuis 2020 les efforts d’IDinsight pour faire évoluer leurs outils de collecte de données et d’analyse. L’organisation travaille également avec nombre de nos partenaires pour renforcer leurs méthodes de suivi et d’évaluation et leur apporter des services de conseils sur mesure. Ceci inclut notamment le renforcement des systèmes de données, la conception ou l’amélioration de la collecte, de l’analyse et de la visualisation des données, ainsi que la conception de théories du changement fondées sur des données probantes et concrètes.  International Center for Research on Women Pays : Rwanda, Tanzanie Financé depuis 2018  L’International Center for Research on Women (ICRW) est un institut de recherche qui s’attaque aux défis auxquels sont confrontés les femmes et les filles partout dans le monde. Nous soutenons ICRW depuis 2018 pour enrichir les connaissances théoriques et pratiques dans le domaine de la mobilisation des hommes et des garçons en faveur de l’égalité des genres. À la suite de l’étude Gender equity and male engagement : it only works when everyone plays (Équité des genres et engagement des hommes : ça ne marche que si tout le monde joue), un programme pilote a été lancé sur le terrain pour mettre en pratique les recommandations de l’étude et développer des stratégies efficaces sur ces questions. Ce pilote est mené au Rwanda et en Tanzanie sur cinq ans, afin de tester des stratégies d’engagement des hommes dans les programmes traditionnels destinés aux femmes de Women for Women International et de Hand in Hand International. Les résultats seront publiés, partagés avec l’ensemble du secteur, et permettront d’éclairer des prises de décisions programmatiques et de financement.  L ES CINQ LEÇ ONS T IRÉES D’UNE DÉC ENNIE D’ENG AG EMENT - 53"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 55-title\" style=\"top:246px;left:100px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/55-title-1.png\">\n        <img class=\"abs halfScale 55-title\" style=\"top:98px;left:145px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/55-text-1.png\">\n        <img class=\"abs halfScale 55-title\" style=\"top:526px;left:184px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/55-text-2.png\">\n        <img class=\"abs halfScale 55-title\" style=\"top:702px;left:97px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/55-text-3.png\">\n\n        <div class=\"single-play pointer abs\" onclick=\"Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/2022-CP-COM-In-Our-Partners-Words-05.mp4')\" style=\"top: 330px; left: 516px;\">\n          <img class=\"abs 55-play halfScaleC halfpulseBig animatedpulse\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/play-big.png\">\n        </div>\n\n        <div class=\"double-play pointer abs\" onclick=\"Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/2022-CP-COM-In-Our-Partners-Words-05.mp4')\" style=\"top: 318px; left: 615px;\">\n          <img class=\"abs 55-play halfScaleC animatedpulse\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/play-big.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg55Anim = new TimelineMax();\n          pg55Anim\n            .staggerFromTo(cOf(\"55-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"55-play\"), 0.9, {className: '+= halfpulseBig', opacity:0, scale: 0}, {opacity: 1, scale: 0.4, ease: Power2.easeOut}, \">\")\n          \n          if (Publish.isDoublePage) {\n            cOf(\"single-play\")[0].style.display = \"none\"\n            cOf(\"single-play\")[1].style.display = \"none\"\n            cOf(\"double-play\")[0].style.display = \"block\"\n          } else {\n            cOf(\"single-play\")[0].style.display = \"block\"\n            cOf(\"single-play\")[1].style.display = \"block\"\n            cOf(\"double-play\")[0].style.display = \"none\"\n          }\n        }\n\n        function onPageLeave() {\n          pg55Anim.stop();\n          resetNumbers(\"55-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "Je dirais catalyseur, car Cartier CATA LYSEUR «Philanthropy investit aujourd’hui  dans des solutions et des idées qui vont, nous l’espérons, changer le secteur et le domaine du développement pour les années à venir. » Meg Battle, Directrice des initiatives stratégiques chez IDinsight  QUEL MOT CHOISISSENT NOS PARTENAIRES POUR NOUS DÉCRIRE  Je choisirais le mot solidarité pour définir SOL ID ARI TÉ «Cartier Philanthropy. Votre équipe comprend  que le travail que nous réalisons ensemble n’est ni une question de pitié ni de problèmes qui ne nous concernent pas, mais qu’il a trait aux injustices et aux disruptions dans un monde qui est de notre responsabilité collective. Il s’agit pour nous de résoudre ces problèmes et de réparer ces injustices ensemble, en tant que partenaires respectifs et partenaires des patients. » Ari Johnson, PDG de Muso  Je vais tricher et utiliser une locution pour dire : CONF IANCE «confiance dans le changement. Non seulement Cartier  Philanthropy finance des organisations fortes, mais surtout, elle leur fait confiance, créant ainsi une latitude pour que l’organisation puisse rester fidèle à sa mission, mais aussi afin qu’elle se développe. Pour moi, c’est l’essence même de la confiance. » Frank Beadle de Palomo, PDG de mothers2mothers  54 -"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 56-title\" style=\"top:99px;left:201px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/56-text-1.png\">\n        <img class=\"abs halfScale 56-title\" style=\"top:232px;left:109px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/56-text-2.png\">\n        <img class=\"abs halfScale 56-title\" style=\"top:394px;left:188px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/56-text-3.png\">\n        <img class=\"abs halfScale 56-title\" style=\"top:557px;left:165px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/56-text-4.png\">\n        <img class=\"abs halfScale 56-title\" style=\"top:702px;left:77px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/56-text-5.png\">\n        <div class=\"single-play play pointer abs\" onclick=\"Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/2022-CP-COM-In-Our-Partners-Words-05.mp4')\" style=\"top: 18px; left: 0px;\">\n          <img class=\"abs 56-play halfScaleC halfpulseBig animatedpulse\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/play-big.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg56Anim = new TimelineMax();\n          pg56Anim\n            .staggerFromTo(cOf(\"56-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1.15)\n            .fromTo(cOf(\"56-play\"), 0.9, {className: '+= halfpulseBig', opacity:0, scale: 0}, {opacity: 1, scale: 0.4, ease: Power2.easeOut}, \">\")\n\n          \n          if (!Publish.isDoublePage) {\n            cOf(\"single-play\")[0].style.display = \"block\"\n            cOf(\"single-play\")[1].style.display = \"block\"\n            cOf(\"double-play\")[0].style.display = \"none\"\n          }\n        }\n\n        function onPageLeave() {\n          pg56Anim.stop();\n          resetNumbers(\"56-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "Sans aucun doute l’empathie. Surtout E MPATHI E «quand je sais que vous avez dédié beaucoup de votre temps à l’écoute et à la compréhension de ce qui se passe, tant avec vos partenaires que sur le terrain. » Debbie Aung Din, Co-fondatrice de Proximity Design  A P PRENT ISSAGE CO N TI N U  « Cartier Philanthropy a toujours soutenu la nécessité d’un apprentissage continu, une valeur partagée avec Room to Read ; nous nous engageons tous deux à trouver des solutions dans ce monde en constante évolution. Loin d’être figés dans nos croyances, nous continuons à écouter les retours du terrain tout en n’ayant de cesse d’apprendre. » Geetha Murali, PDG de Room to Read  Je choisirais réfléchie. Je pense que Cartier RÉ F LÉ CHI E «Philanthropie est une fondation très avisée  dans le choix de ses partenariats, dans les relations qu’elle entretient avec eux et dans la façon dont elle leur fait confiance pour qu’ils prennent eux-mêmes les décisions qui permettront le meilleur impact. » Emily Bancroft, Présidente de VillageReach  d’ordre est impact. Et cela passe IMPA CT «parLeunmot apprentissage basé sur les faits et les  données, donc une philanthropie très réfléchie, qui cherche vraiment à comprendre comment faire de notre Terre un monde meilleur. » Laurie Adams, PDG de Women for Women International  Je choisirais transformatif. Notre relation T R A N SFORMATI F «a été transformative parce que l’équipe de  Cartier Philanthropy nous a toujours incités à remettre en question notre façon de travailler d’une manière constructive et a collaboré étroitement avec nous pour que notre action soit encore plus pertinente, vis à vis des gens que nous nous engageons à servir. » Elena Bonometti, PDG de Tostan  - 55"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 57-title\" style=\"top:431px;left:54px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/57-title-1.png\">\n        <img class=\"abs halfScale 57-title\" style=\"top:464px;left:53px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/57-title-2.png\">\n        <img class=\"abs halfScaleC 57-text\" style=\"top:-467px;left:-182px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/57-text-1.png\">\n        <img class=\"abs halfScaleC 57-text\" style=\"top:182px;left:-105px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/57-text-2.png\">\n        <div class=\"57-text\"></div>\n        <img class=\"abs halfScaleC 57-text\" style=\"top:241px;left:469px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/58-text-2.png\">\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg57Anim = new TimelineMax();\n          pg57Anim\n            .staggerFromTo(cOf(\"57-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1.3)\n            .staggerFromTo(cOf(\"57-text\"), 1, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 0.3, 1.9)\n        }\n\n        function onPageLeave() {\n          pg57Anim.stop();\n          resetNumbers(\"57-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ACCÈS AUX SERVICES DE BASE Éducation Ashesi University CorStone Imagine Worldwide Institut Européen de Coopération et de Développement (IECD) The Luminos Fund Ubongo  Eau, assainissement, nutrition 1001fontaines Semilla Nueva SOIL Water and Sanitation for the Urban Poor (WSUP)  Santé Development Media International (DMI) Healthy Learners MiracleFeet Muso Pivot Santé Integrée UNFPA Supplies Partnership VillageReach  PARTENAIRES  ACTUELS 2022 MODES DE SUBSISTANCE ET ÉCOSYSTÈMES DURABLES BRAC Fonkoze Foundation Hand in Hand International  56 -  Kheyti myAgro One Acre Fund Proximity Designs  Root Capital Village Enterprise VisionSpring World Bicycle Relief"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n      <img class=\"abs halfScaleC 58-text\" style=\"top:-467px;left:-896px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/57-text-1.png\">\n      <img class=\"abs halfScaleC 58-text\" style=\"top:182px;left:-819px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/57-text-2.png\">\n      <img class=\"abs halfScaleC 58-text\" style=\"top:-329px;left:-243px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/58-text-1.png\">\n      <img class=\"abs halfScaleC 58-text\" style=\"top:241px;left:-245px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/58-text-2.png\">\n      <img class=\"abs halfScaleC 58-text\" style=\"top:566px;left:310px;\" src=\"/a-decade-of-effective-philanthropy/fr/static/_content/58-text-3.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax();\n          pg58Anim\n            .staggerFromTo(cOf(\"58-text\"), 1, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 0.3, 1.9)\n        }\n\n        function onPageLeave() {\n          pg58Anim.stop();\n          resetNumbers(\"58-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DÉVELOPPEMENT SOCIAL ET ÉCONOMIQUE DES FEMMES Co-Impact Santé des femmes mothers2mothers MSI Reproductive Choices (MSI) StrongMinds  Opportunités économiques The BOMA Project International Center for Research on Women (ICRW) Saha Global Women for Women International  RÉPONSE AUX SITUATIONS D’URGENCE International Rescue Committee (IRC) Medair Médecins Sans Frontières (MSF)  Programme alimentaire mondial (PAM) SOS Méditerranée  Éducation et compétences de vie Asian University for Women Buildher Educate Girls Room to Read Tostan  SUPPORT TECHNIQUE Appleseed IDinsight  - 57"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"top: 739px; left: 83px; width: 196px; height: 20px;\"> <a href=\"https://www.cartierphilanthropy.org\" target=\"_blank\"></a> </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Crédits photos Couverture : © Cartier Philanthropy / Cyril Le Tourneur © 1001Fontaines (p. 13) © Action contre la Faim / Lucile Grosjean (p. 36) © The BOMA Project (p. 21) © Buildher (p. 48) © Cartier Philanthropy / Andrea Borgarello (p. 12, 19, 24-25, 23, 29, 32, 38, 43, 46) © Cartier Philanthropy / Cyril Le Tourneur (p. 14, 16, 18, 23, 27, 42) © Cartier Philanthropy / Irene Amodei (p. 33) © Cartier Philanthropy / Karin Schermbrucker (p.1, 7, 17, 44) © CorStone (p. 10) © Fédération internationale des sociétés de la Croix-Rouge et du Croissant-Rouge (p. 36) © Hand in Hand International / Georgina Goodwin (p. 49) © Healthy Learners (p. 45) © International Rescue Committee (p. 11) © International Rescue Committee / A. Oberstadt Richmond (p. 33) © The Luminos Fund / Rosie Hallam (p. 41)  Adresse Rue André-De-Garrini 3 – CH-1217 Meyrin-Genève  Site internet www.cartierphilanthropy.org  58 -  © The Luminos Fund / Aron Simeneh (p.10) © Medair / Chrystelle Rakotomavo (p. 37) © Medair / Megan Fraga (p. 31) © Medair (p. 35) © Médecins Sans Frontières / Agnes Varraine Leca (p. 35) © Médecins Sans Frontières / Benoit Finck (p. 37) © Médecins Sans Frontières / Premananda Hessenkamp (p. 35) © mothers2mothers / Karin Schermbrucker (p. 40) © One Acre Fund / Hailey Tucker (p. 27) © Pivot (p. 9) © Root Capital (p. 26) © Saha Global (p. 20) © Santé Integrée (p. 8) © Semilla Nueva (p. 12) © SOIL / Vic Hinterlang (p. 12) © StrongMinds / Jennifer Bass (p. 16) © SOS Méditerranée / Hara Kaminara (p. 32) © Techo (p. 34) © Tostan (p. 47) © Women for Women International / Hazel Thomson (p. 20) © World Bicycle Relief (p. 28)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n        \n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n        contentLinksThree.map(function callback(e) { \n          return e.className = 'addContentLinkThree'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \" \";\n          var decChar = \",\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function animateNumbers(klass, delay = 1, stagger = 0.3) {\n        numbers = cOf(klass)\n      \n        setTimeout(function() {\n          for (let i = 0; i < numbers.length; i++) {\n            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])\n          }\n        }, delay * 1000)\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function individualGallery(index) {\n        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null,
  "articles": [{
    "title": "MESSAGE DU PRÉSIDENT",
    "pageIndex": 6,
    "subIndex": 0,
    "articleIndex": 0,
    "article": "\n        <h2>MESSAGE DU PR\xC9SIDENT</h2>  \n\n        <p>La mission de Cartier est de trouver la beaut\xE9, o\xF9 qu\u2019elle soit. Nous sommes\n          \xE0 son service et, tous les jours, nous nous eff or\xE7ons de la sublimer afi n\n          qu\u2019elle perdure pour les g\xE9n\xE9rations \xE0 venir.</p>\n        \n        <p>Nous estimons qu\u2019il est de notre responsabilit\xE9, \xE0 la fois en tant qu\u2019\xEAtre\n          humain et en tant qu\u2019entreprise, de cultiver et de prot\xE9ger la beaut\xE9 du\n          monde, et de faire tout notre possible pour la restaurer quand elle a \xE9t\xE9\n          d\xE9t\xE9rior\xE9e ou bris\xE9e. La vie humaine est \xE9videmment l\u2019une des</p>\n        beaut\xE9s du monde.\n        \n        <p>La beaut\xE9, telle que nous la concevons, est donc un id\xE9al qui ne peut \xEAtre\n          atteint que par le soin, le respect, la dignit\xE9 et la compassion.</p>\n        \n        <p>Au cours de cette derni\xE8re d\xE9cennie, Cartier Philanthropy a travaill\xE9 avec\n          t\xE9nacit\xE9 et efficacit\xE9 pour am\xE9liorer la vie des communaut\xE9s les plus\n          vuln\xE9rables et les plus marginalis\xE9es de la plan\xE8te, afin qu\u2019elles puissent\n          non seulement survivre aux \xE9preuves, mais vivre, profiter et participer\n          pleinement \xE0 la beaut\xE9 du monde. Une jeune fille qui termine avec succ\xE8s sa\n          scolarit\xE9, une communaut\xE9 d\u2019agriculteurs prosp\xE8re, un endroit s\xFBr o\xF9 trouver\n          refuge et se reconstruire, un nouveau-n\xE9 en bonne sant\xE9\u2026 sont autant\n          d\u2019expressions de la beaut\xE9 - une beaut\xE9 vivante.</p>\n        \n        <p>Cartier Philanthropy soutient des organisations dont la mission est de donner\n          aux femmes, aux enfants et \xE0 des communaut\xE9s enti\xE8res les ressources, les\n          comp\xE9tences et les opportunit\xE9s dont ils ont besoin pour vivre pleinement. Au\n          fil des ann\xE9es, de solides partenariats ont \xE9t\xE9 nou\xE9s et construits sur des\n          valeurs communes et un engagement mutuel en faveur d\u2019une philanthropie\n          efficace.</p>\n        \n        <p>Le chemin est encore long. En effet, \xE0 certaines occasions, il peut m\xEAme nous\n          para\xEEtre plus sinueux qu\u2019il ne l\u2019\xE9tait il y a dix ans. Mais chaque pas et\n          chaque vie chang\xE9e viennent\n          r\xE9affirmer notre confiance et notre d\xE9termination, et ouvrent en peu plus la\n          voie afin que d\u2019autres nous rejoignent pour cr\xE9er ensemble de nouvelles\n          beaut\xE9s dans le monde.</p>\n\n        <!-- <p>\n          <b>Cyrille Vigneron</b><br>\n          CEO of Cartier,<br>\n          President of the Board,<br>\n          Cartier Philanthropy\n        </p> -->\n      "
  }, {
    "title": "MESSAGE DE LA CONSEILLÈRE STRATÉGIQUE",
    "pageIndex": 7,
    "subIndex": 0,
    "articleIndex": 1,
    "article": "\n        <h2>MESSAGE DE LA CONSEILL\xC8RE STRAT\xC9GIQUE</h2> \n        <p>Quelle aventure ces dix derni\xE8res ann\xE9es !</p>\n        <p>Et quel privil\xE8ge que celui de guider Cartier Philanthropy, des promesses\n          initiales aux progr\xE8s tangibles, en cr\xE9ant un solide r\xE9seau de partenaires\n          dont nous sommes tr\xE8s fiers !</p>\n        <p>Nous sommes aujourd\u2019hui heureux de voir, aux quatre coins du monde, des\n          communaut\xE9s plus fortes et pleines de ressources, en mesure de surmonter de\n          s\xE9rieux obstacles et de vivre enfin comme elles le m\xE9ritent.</p>\n        <p>Cartier Philanthropy a \xE9t\xE9 fond\xE9 il y a dix ans afin de participer \xE0 la\n          construction d\u2019un monde dans lequel chacun peut r\xE9aliser son potentiel. Au\n          cours de la derni\xE8re d\xE9cennie, nous nous sommes concentr\xE9s sur cette ambition\n          de mani\xE8re strat\xE9gique. Nous avons choisi de nous focaliser sur les endroits\n          les plus vuln\xE9rables de la plan\xE8te et avons progressivement d\xE9fini le cadre de\n          notre champ d\u2019action, en accordant une attention particuli\xE8re aux in\xE9galit\xE9s\n          qui maintiennent les gens dans la pauvret\xE9.</p>\n        La philanthropie rel\xE8ve de l\u2019action collective et d\u2019objectifs communs. Avec nos\n        partenaires, nous nous attaquons sans rel\xE2che \xE0 ces in\xE9galit\xE9s, qu\u2019elles soient\n        li\xE9es au genre, \xE0 l\u2019acc\xE8s aux services essentiels ou au manque de ressources\n        mat\xE9rielles et sociales. Ce rapport met en lumi\xE8re l\u2019impact de notre engagement\n        collectif et les changements concrets qui ont permis d\u2019am\xE9liorer la vie des plus\n        d\xE9munis. C\u2019est notre fa\xE7on d\u2019honorer nos partenaires pour leur courage et leur\n        d\xE9termination dans leur combat au service des plus vuln\xE9rables, quelles que\n        soient les difficult\xE9s.\n        <p>Car ce combat est aussi le n\xF4tre.</p>\n        <p>Conscients qu\u2019une \xE9volution significative et durable ne se produit que si\n          nous nous concentrons aussi sur notre fa\xE7on de donner afin de contribuer \xE0 un\n          impact social fort, nous partageons aussi dans ce rapport certaines des le\xE7ons\n          que nous avons apprises en chemin, nous aidant \xE0 devenir une fondation\n          meilleure, plus efficace, responsable et participante.</p>\n        <p>Construire une soci\xE9t\xE9 inclusive, \xE9quitable et plus s\xFBre, qui offre \xE0 chacun\n          la possibilit\xE9 de mener une vie \xE9panouissante, reste un imp\xE9ratif moral et le\n          d\xE9fi de notre \xE9poque. Notre engagement demeure inchang\xE9, tout comme notre\n          ambition de soutenir et de d\xE9ployer des interventions \xE9prouv\xE9es \xE0 l\u2019\xE9chelle\n          des besoins du plus grand nombre.</p>\n\n        <!-- <p>\n          <b>Pascale de la Fr\xE9gonni\xE8re</b><br>\n          Strategic Advisor to the Board,<br>\n          Cartier Philanthropy\n        </p> -->\n      "
  }, {
    "title": "1. FINANCER L’IMPACT",
    "pageIndex": 43,
    "subIndex": 0,
    "articleIndex": 2,
    "article": "\n        <h2>1. FINANCER L\u2019IMPACT.</h2> \n        <p>Il y a tant \xE0 faire aujourd\u2019hui - et les besoins sont si urgents - que nous ne pouvons pas nous permettre de gaspiller de l\u2019argent, du temps ou de l\u2019\xE9nergie sur des programmes qui ne fonctionnent pas.</p>\n        <p>Notre premi\xE8re responsabilit\xE9, en tant que bailleur, est de nous assurer que chaque dollar investi apporte un changement positif, concret et tangible dans la vie des personnes pour lesquelles nous nous engageons. Pour ce faire, nous devons soutenir des solutions \xE9prouv\xE9es, \xE9tay\xE9es par des donn\xE9es probantes, et qui auront des r\xE9sultats impactants.</p>\n        <p><b>mothers2mothers</b><br>\n        Pays : Ouganda<br>\n        Financ\xE9 depuis 2017</p>\n        <p>mothers2mothers (m2m) emploie des femmes vivant avec le VIH-SIDA afin qu\u2019elles facilitent l\u2019acc\xE8s d\u2019autres femmes et de leur famille aux services essentiels et aux soins de sant\xE9.\n          Le programme se concentre sur la r\xE9duction du risque d\u2019infection au VIH et aux maladies associ\xE9es. Depuis 2017, notre soutien a permis \xE0 m2m de d\xE9ployer ses services de sant\xE9 int\xE9gr\xE9e en Ouganda pour r\xE9duire la transmission du virus des femmes enceintes et s\xE9ropositives \xE0 leur b\xE9b\xE9 et pour pr\xE9server plus en g\xE9n\xE9ral la sant\xE9 des femmes et des enfants.\n          </p>\n        <p>Au cours de ces vingt derni\xE8res ann\xE9es, les efforts de m2m ont permis l\u2019\xE9limination presque totale de la transmission du virus de la m\xE8re \xE0 l\u2019enfant parmi les femmes encadr\xE9es par son programme : en Afrique orientale et australe, le taux de transmission du VIH de ces femmes \xE0 leur enfant est pass\xE9 de 40 % \xE0 0,8 % et la mortalit\xE9 infantile a \xE9t\xE9 abaiss\xE9e \xE0 deux d\xE9c\xE8s pour 1 000 naissances.</p>\n        <p><b>The Luminos Fund</b><br>\n        Pays : \xC9thiopie<br>\n        Financ\xE9 depuis 2018</p>\n        <p>Le programme d\u2019apprentissage acc\xE9l\xE9r\xE9 de Luminos Fund, \xAB Seconde Chance \xBB, a d\xE9j\xE0 permis \xE0 plus de 152 000 enfants africains, qui n\u2019ont jamais \xE9t\xE9 scolaris\xE9s ou qui ont\n          d\xFB interrompre leur \xE9ducation \xE0 cause de la pauvret\xE9, d\u2019un conflit ou de la discrimination, de retrouver les bancs de l\u2019\xE9cole. Depuis 2018, nous soutenons l\u2019expansion rapide du programme dans les r\xE9gions recul\xE9es d\u2019Afar et d\u2019Oromia, en \xC9thiopie.\n          </p>\n        <p>Parmi les 26 850 \xE9l\xE8ves inscrits dans les classes de \xAB Seconde Chance \xBB, entre 2018 et 2021, 91 % \xE0 97 % d\u2019entre eux ont r\xE9ussi leur transition vers des \xE9coles publiques et poursuivent leur \xE9ducation. Quelque 9 000 enfants suppl\xE9mentaires ont b\xE9n\xE9fici\xE9 du programme mis en oeuvre directement par le gouvernement. Six ans plus tard, 75 % des \xE9l\xE8ves de \xAB Seconde Chance \xBB sont toujours scolaris\xE9s.</p>\n      "
  }, {
    "title": "2. UN FINANCEMENT À LONG TERME ET SANS RESTRICTION",
    "pageIndex": 45,
    "subIndex": 0,
    "articleIndex": 3,
    "article": "\n        <h2>2. UN FINANCEMENT \xC0 LONG TERME ET SANS RESTRICTION.</h2> \n        <p>Nous travaillons sur des questions tr\xE8s complexes et multidimensionnelles et, \xE0 ce titre, nous ne nous attendons pas \xE0 des r\xE9sultats imm\xE9diats, d\u2019un jour \xE0 l\u2019autre. Notre engagement se fait sur le long terme. Soutenir des projets sur deux ou trois ans seulement reviendrait \xE0 choisir une approche de type \xAB cases \xE0 cocher \xBB. Nous avons fait le choix d\u2019investir sur le long terme et sur la cr\xE9ation d\u2019alliances solides, en aidant nos partenaires \xE0 se d\xE9velopper, \xE0 renforcer leur impact et \xE0 \xE9largir le champ de leurs op\xE9rations. Fournir un financement sans restriction, que les organisations \xE0 but non lucratif g\xE8rent comme elles l\u2019entendent, est s\xFBrement la mesure la plus transformatrice que nous puissions prendre pour v\xE9ritablement les aider \xE0 atteindre leurs objectifs.</p>\n        <p><b>Educate Girls</b><br>\n        Pays : Inde<br>\n        Financ\xE9 depuis 2014</p>\n        <p>Educate Girls s\u2019attaque aux in\xE9galit\xE9s entre les sexes et aux barri\xE8res qui emp\xEAchent les filles d\u2019aller \xE0 l\u2019\xE9cole dans les villages ruraux les plus isol\xE9s de l\u2019Inde. Partant d\u2019un projet pilote portant sur 50 \xE9coles en 2007, Educate Girls couvre aujourd\u2019hui plus de 20 000 villages au Rajasthan, au Madhya Pradesh et en Uttar Pradesh.</p>\n        <p>Au fil des ans, Educate Girls a obtenu des r\xE9sultats impressionnants en mati\xE8re d\u2019inscription, de r\xE9tention et d\u2019apprentissage. Les visites \xE0 domicile et la sensibilisation des communaut\xE9s sont au c\u0153ur de son succ\xE8s. Educate Girls exploite \xE9galement les ressources gouvernementales pour am\xE9liorer les infrastructures, la gouvernance et l\u2019enseignement des \xE9coles publiques.</p>\n        <p>Nous finan\xE7ons l\u2019approche unique d\u2019Educate Girls depuis 2014, contribuant \xE0 la scolarisation de plus de 1,1 million de filles. Aujourd\u2019hui, nous soutenons l\u2019organisation pour qu\u2019elle touche 1,5 million de filles d\u2019ici 2024.</p>\n        <p><b>Room to Read</b><br>\n        Pays : Bangladesh, Cambodge, sans restriction<br>\n        Financ\xE9 depuis 2019</p>\n        <p>Room to Read cherche \xE0 transformer la vie de millions d\u2019enfants vivant dans des communaut\xE9s \xE0 faible revenu en se concentrant sur l\u2019alphab\xE9tisation et l\u2019\xE9galit\xE9 des genres dans l\u2019\xE9ducation. En collaborant avec les communaut\xE9s locales, les gouvernements et des organisations partenaires, Room to Read d\xE9veloppe l\u2019alphab\xE9tisation et inculque l\u2019habitude de la lecture aux enfants des \xE9coles primaires.</p>\n        <p>Depuis 2019, nous soutenons son Programme d\u2019\xE9ducation pour les filles au Bangladesh et au Cambodge, permettant aux adolescentes d\u2019acqu\xE9rir et de mettre en pratique - par des cours, des ateliers et des activit\xE9s extrascolaires - des connaissances et des comp\xE9tences de vie afin qu\u2019elles puissent poursuivre leurs \xE9tudes et prendre des d\xE9cisions \xE9clair\xE9es pour leur futur. Depuis juillet 2022, nous offrons \xE0 l\u2019organisation un soutien financier sans restriction.</p>\n      "
  }, {
    "title": "3. INNOVER C’EST BIEN, MAIS RENDRE ACCESSIBLES AU PLUS GRAND NOMBRE DES SOLUTIONS ÉPROUVÉES C’EST ENCORE MIEUX",
    "pageIndex": 47,
    "subIndex": 0,
    "articleIndex": 4,
    "article": "\n        <h2>3. INNOVER C\u2019EST BIEN, MAIS RENDRE ACCESSIBLES AU PLUS GRAND NOMBRE DES SOLUTIONS \xC9PROUV\xC9ES C\u2019EST ENCORE MIEUX.</h2> \n        <p>Au vu de l\u2019urgence et de l\u2019intensit\xE9 des probl\xE8mes sociaux actuels, si l\u2019ensemble de la communaut\xE9 philanthropique est s\xE9duite par l\u2019innovation et se concentre uniquement sur celle-ci, nous ne serons jamais en mesure de rendre accessibles au plus grand nombre les solutions qui fonctionnent d\xE9j\xE0. En d\u2019autres termes, nous n\u2019avons pas besoin d\u2019un million d\u2019innovations, mais d\u2019une seule qui fonctionne, r\xE9pliqu\xE9e un million de fois, afin que son impact soit \xE0 la hauteur des besoins.</p>\n        <p><b>StrongMinds</b><br>\n        Pays : Ouganda, Zambie<br>\n        Financ\xE9 depuis 2018</p>\n        <p>L\u2019OMS promeut les th\xE9rapies de groupe en tant qu\u2019intervention de sant\xE9 mentale de premi\xE8re ligne pour les populations vuln\xE9rables. StrongMinds est la seule organisation \xE0 mettre en oeuvre cette solution efficace pour lutter contre la d\xE9pression en Afrique. StrongMinds forme et supervise des agents communautaires pour qu\u2019ils deviennent des animateurs en sant\xE9 mentale charg\xE9s d\u2019encadrer des groupes de parole. Ces th\xE9rapies ciblent les femmes souffrant de d\xE9pression au sein des communaut\xE9s d\xE9favoris\xE9es, o\xF9 la pr\xE9valence de la d\xE9pression, avec un taux affichant 25 %, est tr\xE8s pr\xE9sente. Des groupes de 10 \xE0 15 femmes se r\xE9unissent pour des s\xE9ances hebdomadaires de 90 minutes, o\xF9 elles apprennent \xE0 identifier les d\xE9clencheurs de la d\xE9pression, elles partagent des strat\xE9gies permettant de combattre les sympt\xF4mes et, \xE0 plus long terme, elles apprennent \xE0 devenir plus r\xE9silientes. StrongMinds permet ensuite aux femmes arriv\xE9es au terme du programme de se former pour encadrer leurs propres groupes de parole, ce qui amplifie l\u2019impact du programme sur le long terme.</p>\n        <p>Nous soutenons StrongMinds depuis 2018 afin que l\u2019organisation d\xE9veloppe en Zambie le mod\xE8le mis en place en Ouganda. L\u2019organisation est d\xE9sormais devenue conseill\xE8re technique du minist\xE8re zambien de la Sant\xE9 en mati\xE8re de sant\xE9 mentale.</p>\n        <p><b>Healthy Learners</b><br>\n        Pays : Zambie<br>\n        Financ\xE9 depuis 2019</p>\n        <p>Healthy Learners s\u2019engage \xE0 am\xE9liorer la sant\xE9 des enfants de plus de cinq ans gr\xE2ce \xE0 son programme de sant\xE9 communautaire en milieu scolaire. L\u2019organisation forme les enseignants \xE0 reconna\xEEtre les sympt\xF4mes des maladies courantes chez les \xE9l\xE8ves et \xE0 leur prodiguer les soins de base ou \xE0 les r\xE9f\xE9rer \xE0 des centres de sant\xE9. Plus vite l\u2019enfant malade est identifi\xE9 et soign\xE9, plus vite il reprendra l\u2019\xE9cole.</p>\n        <p>Depuis le d\xE9but de notre collaboration en 2019, Healthy Learners a syst\xE9matis\xE9 son programme et renforc\xE9 sa collaboration avec les minist\xE8res zambiens de la Sant\xE9 et de l\u2019\xC9ducation pour inscrire ce dispositif dans la strat\xE9gie nationale de sant\xE9 scolaire.</p>\n      "
  }, {
    "title": "4. TROUVER LE BON ÉQUILIBRE DANS LA DYNAMIQUE DU POUVOIR",
    "pageIndex": 47,
    "subIndex": 0,
    "articleIndex": 5,
    "article": "\n        <h2>4. TROUVER LE BON \xC9QUILIBRE DANS LA DYNAMIQUE DU POUVOIR.</h2> \n        <p>Lorsqu\u2019il est question de modifier ou d\u2019am\xE9liorer les pratiques philanthropiques, la responsabilit\xE9 incombe aux bailleurs. La dynamique du pouvoir exige que les bailleurs eux-m\xEAmes remettent en question la nature de leurs relations avec les organisations financ\xE9es. Il faut donc avant tout reconna\xEEtre l\u2019existence d\u2019un d\xE9s\xE9quilibre de pouvoir qui peut emp\xEAcher, s\u2019il n\u2019est pas assum\xE9, une collaboration honn\xEAte et fructueuse. Nos partenaires attendent de nous que nous soyons flexibles, pragmatiques, \xE0 l\u2019\xE9coute de leurs besoins et de leurs difficult\xE9s et pr\xEAts \xE0 amplifier et \xE0 faire conna\xEEtre leur travail. Mais avant toute chose, ils ont besoin de notre confiance. Ces derni\xE8res ann\xE9es, nous avons intentionnellement cr\xE9\xE9 des occasions d\u2019\xE9changes avec nos partenaires afin qu\u2019ils puissent librement exprimer leurs doutes, remettre en question nos demandes ou exposer les changements de strat\xE9gie envisag\xE9s. Favoriser ainsi le dialogue a permis d\u2019\xE9tablir des relations de confiance, qui sont \xE0 la base des progr\xE8s r\xE9alis\xE9s ensemble.</p>\n        <p><b>Village Enterprise</b><br>\n        Pays : Ouganda<br>\n        Financ\xE9 depuis 2016</p>\n        <p>Le programme de formation de Village Enterprise vient en aide aux personnes vivant dans l\u2019extr\xEAme pauvret\xE9, en leur permettant de d\xE9velopper des moyens de subsistance durables. L\u2019organisation fournit aux participants une aide financi\xE8re, une formation en entrepreneuriat et en finance, ainsi qu\u2019un mentorat continu pour les aider \xE0 cr\xE9er des micro-entreprises de trois personnes et \xE0 constituer des groupes d\u2019\xE9pargne.</p>\n        <p>Nous soutenons Village Enterprise en Ouganda, o\xF9 l\u2019organisation est active depuis 2016. Aujourd\u2019hui, ses activit\xE9s s\u2019\xE9tendent dans plusieurs pays d\u2019Afrique subsaharienne et ont pour objectif de permettre \xE0 plus de 20 millions de personnes d\u2019\xE9chapper \xE0 la pauvret\xE9 d\u2019ici 2030. Notre collaboration avec Village Enterprise n\u2019a eu de cesse d\u2019\xE9voluer ces derni\xE8res ann\xE9es jusqu\u2019\xE0 devenir un partenariat solide, ax\xE9 sur le dialogue, la transparence et la confiance. En plus d\u2019un soutien financier flexible, nous sommes fiers de les accompagner dans leurs discussions strat\xE9giques et de les soutenir activement dans leurs d\xE9marches de recherche de financements suppl\xE9mentaires.</p>\n        <p><b>Tostan</b><br>\n        Pays : Gambie, Guin\xE9ee-Bissau et S\xE9n\xE9gal<br>\n        Financ\xE9 depuis 2016</p>\n        <p>Tostan a mis sur pied un mod\xE8le participatif sur trois ans qui permet aux jeunes, aux adultes, aux personnes \xE2g\xE9es et aux leaders communautaires de se former aux droits de l\u2019homme, \xE0 l\u2019hygi\xE8ne et \xE0 la sant\xE9, \xE0 la r\xE9solution de conflits, \xE0 l\u2019autonomie \xE9conomique et \xE0 l\u2019\xE9ducation des enfants. Le programme aborde aussi des notions \xE9l\xE9mentaires de lecture, d\u2019\xE9criture et de calcul. Ce mod\xE8le de d\xE9veloppement communautaire favorise le changement social et comportemental, en encourageant les villageois \xE0 remettre en question des pratiques dangereuses profond\xE9ment ancr\xE9es. L\u2019un des succ\xE8s de Tostan est l\u2019engagement de plus de 9 000 communaut\xE9s \xE0 mettre fin au mariage des enfants et \xE0 l\u2019excision.</p>\n        <p>Nous soutenons Tostan au S\xE9n\xE9gal depuis 2018 ; aujourd\u2019hui nous finan\xE7ons l\u2019organisation pour qu\u2019elle puisse toucher plus de 107 500 personnes vivant dans des communaut\xE9s recul\xE9es en Gambie, au S\xE9n\xE9gal et en Guin\xE9e-Bissau. Notre partenariat avec Tostan grandit et se r\xE9v\xE8le toujours plus authentique et pertinent ann\xE9e apr\xE8s ann\xE9e. Elena Bonometti, directrice de Tostan, parle d\u2019une relation \xAB transformative \xBB avec Cartier Philanthropy, qui nous pousse ensemble \xE0 nous remettre en question et \xE0 \xEAtre lucides face aux d\xE9fis auxquels nous sommes confront\xE9s et aux attentes qu\u2019ils suscitent. Notre relation en sort renforc\xE9e et enti\xE8rement d\xE9di\xE9e aux communaut\xE9s que nous servons.</p>\n      "
  }, {
    "title": "5. S’ENGAGER SUR DES RÉSULTATS ET ASSUMER SES RESPONSABILITÉS",
    "pageIndex": 47,
    "subIndex": 0,
    "articleIndex": 6,
    "article": "\n        <h2>5. S\u2019ENGAGER SUR DES R\xC9SULTATS ET ASSUMER SES RESPONSABILIT\xC9S.</h2> \n        <p>Nous \u0153uvrons dans un secteur o\xF9 nous pouvons librement choisir quelle voie prendre. Nous d\xE9finissons notre mission et notre vision et nous s\xE9lectionnons nos partenaires selon nos propres crit\xE8res. Nous d\xE9cidons de ce que nous allons consid\xE9rer comme un succ\xE8s ou un \xE9chec. Si nous voulons \xEAtre vraiment sinc\xE8res en mati\xE8re de progr\xE8s et d\u2019impact social, il nous faut alors \xE9valuer les r\xE9sultats sur la base de donn\xE9es rigoureuses et les assumer \xE0 travers une communication publique. Il nous semble important de r\xE9v\xE9ler de mani\xE8re transparente les r\xE9sultats que nous attendons et les objectifs fix\xE9s. De m\xEAme que nous c\xE9l\xE9brerons nos succ\xE8s, il est \xE9galement de notre devoir d\u2019admettre et de partager nos \xE9checs afin d\u2019en tirer des le\xE7ons utiles pour tous.</p>\n        <p><b>IDinsight</b><br>\n        Pays : Inde, Kenya, Myanmar, Zambie<br>\n        Financ\xE9 depuis 2020</p>\n        <p>Les organisations \xE0 but non lucratif fournissent des services essentiels aux populations les plus pauvres du monde. Cette mission cruciale n\xE9cessite de disposer de donn\xE9es probantes pour optimiser la conception des programmes, am\xE9liorer leur mise en oeuvre et maximiser leur impact. IDinsight est une organisation internationale de conseil, d\u2019analyse de donn\xE9es et de recherche qui accompagne les leaders du d\xE9veloppement \xE0 produire et \xE0 utiliser des donn\xE9es dans leur prise de d\xE9cision. </p>\n        <p>Nous soutenons depuis 2020 les efforts d\u2019IDinsight pour faire \xE9voluer leurs outils de collecte de donn\xE9es et d\u2019analyse. L\u2019organisation travaille \xE9galement avec nombre de nos partenaires pour renforcer leurs m\xE9thodes de suivi et d\u2019\xE9valuation et leur apporter des services de conseils sur mesure. Ceci inclut notamment le renforcement des syst\xE8mes de donn\xE9es, la conception ou l\u2019am\xE9lioration de la collecte, de l\u2019analyse et de la visualisation des donn\xE9es, ainsi que la conception de th\xE9ories du changement fond\xE9es sur des donn\xE9es probantes et concr\xE8tes.</p>\n        <p><b>International Center for Research on Women</b><br>\n        Pays : Rwanda, Tanzanie<br>\n        Financ\xE9 depuis 2018</p>\n        <p>L\u2019International Center for Research on\n          Women (ICRW) est un institut de recherche\n          qui s\u2019attaque aux d\xE9fis auxquels sont\n          confront\xE9s les femmes et les filles partout\n          dans le monde. Nous soutenons ICRW\n          depuis 2018 pour enrichir les connaissances\n          th\xE9oriques et pratiques dans le domaine\n          de la mobilisation des hommes et des gar\xE7ons\n          en faveur de l\u2019\xE9galit\xE9 des genres.\n          </p>\n        <p>\xC0 la suite de l\u2019\xE9tude Gender equity and male engagement : it only works when everyone plays (\xC9quit\xE9 des genres et engagement des hommes : \xE7a ne marche que si tout le monde joue), un programme pilote a \xE9t\xE9 lanc\xE9 sur le terrain pour mettre en pratique les recommandations de l\u2019\xE9tude et d\xE9velopper des strat\xE9gies efficaces sur ces questions. Ce pilote est men\xE9 au Rwanda et en Tanzanie sur cinq ans, afin de tester des strat\xE9gies d\u2019engagement des hommes dans les programmes traditionnels destin\xE9s aux femmes de Women for Women International et de Hand in Hand International. Les r\xE9sultats seront publi\xE9s, partag\xE9s avec l\u2019ensemble du secteur, et permettront d\u2019\xE9clairer des prises de d\xE9cisions programmatiques et de financement.</p>\n      "
  }] });
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }

    var evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);

    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
          //  if(context.getters.currentPage.pageIndex == 0){
          //   context.commit('UPDATE_IS_FRONT_PAGE', true)
          // } else {
          //   context.commit('UPDATE_IS_FRONT_PAGE', false)
          // }
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
          // if(context.getters.currentPage.pageIndex == 0){
          //   context.commit('UPDATE_IS_FRONT_PAGE', true)
          // } else {
          //   context.commit('UPDATE_IS_FRONT_PAGE', false)
          // }
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
          //  if(context.getters.currentPage.pageIndex == 0){
          //   context.commit('UPDATE_IS_FRONT_PAGE', true)
          // } else {
          //   context.commit('UPDATE_IS_FRONT_PAGE', false)
          // }
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
          //  if(context.getters.currentPage.pageIndex == 0){
          //   context.commit('UPDATE_IS_FRONT_PAGE', true)
          // } else {
          //   context.commit('UPDATE_IS_FRONT_PAGE', false)
          // }
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changePageSize: function changePageSize(context, payload) {
    var pageWidth = context.getters.width;
    if (context.getters.currentPage.pageIndex == 0) {
      context.commit('UPDATE_IS_FRONT_PAGE', true);
    } else {
      context.commit('UPDATE_IS_FRONT_PAGE', false);
    }
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var currentPage = context.getters.currentPage;
    var pageWidth = context.getters.width;
    if (currentPage.pageIndex == 0) {
      pageWidth = 2 * context.getters.width;
    }
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    // console.log(widthRatio)
    // console.log(pageWidth)
    var heightRatio = windowHeight / pageHeight;
    // console.log(heightRatio)
    // console.log(pageHeight)
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openArticle: function openArticle(context, payload) {
    context.commit('OPEN_ARTICLE', payload);
    context.dispatch('syncPage', context.getters.articles[payload].pageIndex);
  },
  closeArticle: function closeArticle(context, payload) {
    context.commit('CLOSE_ARTICLE');
  },


  goToArticle: function goToArticle(context, payload) {
    return context.dispatch('openArticle', payload);
  },
  goToPreviousArticle: function goToPreviousArticle(context) {
    return context.dispatch('openArticle', context.getters.previousArticleIndex);
  },
  goToNextArticle: function goToNextArticle(context) {
    return context.dispatch('openArticle', context.getters.nextArticleIndex);
  },

  increaseArticleFontSize: function increaseArticleFontSize(context, payload) {
    return context.commit('INCREASE_ARTICLE_FONT_SIZE', payload);
  },
  decreaseArticleFontSize: function decreaseArticleFontSize(context, payload) {
    return context.commit('DECREASE_ARTICLE_FONT_SIZE', payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  isArticle: function isArticle(state) {
    return state.isArticle;
  },
  articleFontSize: function articleFontSize(state) {
    return state.articleFontSize;
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    var evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);

    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    var evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);

    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length - 1) return null;
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    } else {
      if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  },

  //#endregion

  //#region doublePage

  //#endregion

  articles: function articles(state) {
    return state.document.articles;
  },
  articlesEnabled: function articlesEnabled(state) {
    return state.document.options.articlesEnabled;
  },
  currentArticle: function currentArticle(state, getters) {
    if (!getters.isArticle) return;
    return getters.articles[state.articleIndex];
  },
  nextArticle: function nextArticle(state, getters) {
    if (!getters.isArticle) return;
    if (getters.currentArticle.articleIndex == getters.articles.length - 1) {
      return getters.articles[state.articleIndex];
    }
    return getters.articles[state.articleIndex + 1];
  },
  previousArticle: function previousArticle(state, getters) {
    if (!getters.isArticle) return;
    if (getters.currentArticle.articleIndex == 0) {
      return getters.articles[state.articleIndex];
    }
    return getters.articles[state.articleIndex - 1];
  },
  previousArticleIndex: function previousArticleIndex(state, getters) {
    if (getters.previousArticle) {
      return getters.previousArticle.articleIndex;
    }
    return null;
  },
  nextArticleIndex: function nextArticleIndex(state, getters) {
    if (getters.nextArticle) {
      return getters.nextArticle.articleIndex;
    }
    return null;
  }
});
// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_FRONT_PAGE, function (state, payload) {
  console.log(payload);
  if (payload) {
    state.document.width = 1448;
    console.log(state.document.width);
  } else {
    state.document.width = 724;
    console.log(state.document.width);
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, OPEN_ARTICLE, function (state, payload) {
  state.isArticle = true;
  state.articleIndex = payload;
  // document.getElementsByClassName('article-content')[0].scrollIntoView(true)
}), defineProperty_default()(_types$RESET_SECTION_, CLOSE_ARTICLE, function (state, payload) {
  state.isArticle = false;
}), defineProperty_default()(_types$RESET_SECTION_, INCREASE_ARTICLE_FONT_SIZE, function (state, payload) {
  var x = document.getElementById('article-container');
  x.style.fontSize = state.articleFontSize.toString() + "em";
  if (state.articleFontSize < 1.6) {
    state.articleFontSize += .2;
  }
  x.style.fontSize = state.articleFontSize.toString() + "em";
}), defineProperty_default()(_types$RESET_SECTION_, DECREASE_ARTICLE_FONT_SIZE, function (state, payload) {
  var x = document.getElementById('article-container');
  x.style.fontSize = state.articleFontSize.toString() + "em";
  if (state.articleFontSize > 1) {
    state.articleFontSize -= .2;
  }
  x.style.fontSize = state.articleFontSize.toString() + "em";
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isArticle: false,
    articleIndex: 0,
    articleFontSize: 1
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      // if(Publish.isMobile && document.documentElement.dataset.mobile == "iOS") {
      //   console.log("HAMMER SWIPE")
      //   // var element = document.querySelector('.article-page');
      //   console.log(window.innerWidth);
      //   console.log(e.center.x - e.deltaX)
      //   if ((e.center.x - e.deltaX) < 30 || (e.center.x - e.deltaX) > window.innerwidth - 30) {
      //     // prevent swipe to navigate gesture
      //     e.preventDefault();
      //   }
      // } else 
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.isArticle && !Publish.isZoomed) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.goToNextArticle();
            } else {
              Publish.goToPreviousArticle();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.goToPreviousArticle();
            } else {
              Publish.goToNextArticle();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isArticle) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.goToPreviousArticle();
        } else {
          Publish.goToNextArticle();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.goToNextArticle();
        } else {
          Publish.goToPreviousArticle();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    // this.actualResizeHandler()
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    console.log('actualResizeHandler#');
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-198877654-11',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL", "isArticle", "nextArticle", "previousArticle", "currentArticle", "showArticles", "articlesEnabled"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio", "openArticle", "closeArticle", "goToArticle", "goToNextArticle", "goToPreviousArticle"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RIzX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UFQQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X3WW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJtY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wA9t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c6827c47c9fd11ab50c0.js